var map = {
	".": 120,
	"./": 120,
	"./App": 147,
	"./App.js": 147,
	"./App.test": 254,
	"./App.test.js": 254,
	"./ImageLoder": 1,
	"./ImageLoder.js": 1,
	"./PageHOC": 3,
	"./PageHOC.js": 3,
	"./apis": 26,
	"./apis.js": 26,
	"./index": 120,
	"./index.js": 120,
	"./layouts/AccessibilityWrapper": 20,
	"./layouts/AccessibilityWrapper.js": 20,
	"./layouts/CommonDatePicker": 29,
	"./layouts/CommonDatePicker.js": 29,
	"./layouts/CommonPhoneSlider": 9,
	"./layouts/CommonPhoneSlider.js": 9,
	"./layouts/Footer": 4,
	"./layouts/Footer.js": 4,
	"./layouts/NavigationMenu": 148,
	"./layouts/NavigationMenu.js": 148,
	"./layouts/ScrollToTop": 149,
	"./layouts/ScrollToTop.js": 149,
	"./layouts/caregiver": 51,
	"./layouts/caregiver/": 51,
	"./layouts/caregiver/index": 51,
	"./layouts/caregiver/index.js": 51,
	"./layouts/caregiverRedemption": 52,
	"./layouts/caregiverRedemption/": 52,
	"./layouts/caregiverRedemption/index": 52,
	"./layouts/caregiverRedemption/index.js": 52,
	"./layouts/cbhr": 108,
	"./layouts/cbhr/": 108,
	"./layouts/cbhr/index": 108,
	"./layouts/cbhr/index.js": 108,
	"./layouts/childGrowth": 53,
	"./layouts/childGrowth/": 53,
	"./layouts/childGrowth/index": 53,
	"./layouts/childGrowth/index.js": 53,
	"./layouts/clinicalAllergy": 54,
	"./layouts/clinicalAllergy/": 54,
	"./layouts/clinicalAllergy/index": 54,
	"./layouts/clinicalAllergy/index.js": 54,
	"./layouts/clinicalAppointment": 55,
	"./layouts/clinicalAppointment/": 55,
	"./layouts/clinicalAppointment/index": 55,
	"./layouts/clinicalAppointment/index.js": 55,
	"./layouts/clinicalInvestigation": 56,
	"./layouts/clinicalInvestigation/": 56,
	"./layouts/clinicalInvestigation/index": 56,
	"./layouts/clinicalInvestigation/index.js": 56,
	"./layouts/clinicalMedication": 57,
	"./layouts/clinicalMedication/": 57,
	"./layouts/clinicalMedication/index": 57,
	"./layouts/clinicalMedication/index.js": 57,
	"./layouts/clinicalVaccine": 58,
	"./layouts/clinicalVaccine/": 58,
	"./layouts/clinicalVaccine/index": 58,
	"./layouts/clinicalVaccine/index.js": 58,
	"./layouts/covid19Adolescent": 140,
	"./layouts/covid19Adolescent/": 140,
	"./layouts/covid19Adolescent/index": 140,
	"./layouts/covid19Adolescent/index.js": 140,
	"./layouts/covid19Minors": 59,
	"./layouts/covid19Minors/": 59,
	"./layouts/covid19Minors/index": 59,
	"./layouts/covid19Minors/index.js": 59,
	"./layouts/covid19QR": 60,
	"./layouts/covid19QR/": 60,
	"./layouts/covid19QR/index": 60,
	"./layouts/covid19QR/index.js": 60,
	"./layouts/doctorSearch": 61,
	"./layouts/doctorSearch/": 61,
	"./layouts/doctorSearch/index": 61,
	"./layouts/doctorSearch/index.js": 61,
	"./layouts/donwloadAPK": 109,
	"./layouts/donwloadAPK/": 109,
	"./layouts/donwloadAPK/index": 109,
	"./layouts/donwloadAPK/index.js": 109,
	"./layouts/downloadBg": 62,
	"./layouts/downloadBg/": 62,
	"./layouts/downloadBg/index": 62,
	"./layouts/downloadBg/index.js": 62,
	"./layouts/downloadSticker": 63,
	"./layouts/downloadSticker/": 63,
	"./layouts/downloadSticker/index": 63,
	"./layouts/downloadSticker/index.js": 63,
	"./layouts/ehealthFaq": 64,
	"./layouts/ehealthFaq/": 64,
	"./layouts/ehealthFaq/T-index": 266,
	"./layouts/ehealthFaq/T-index.js": 266,
	"./layouts/ehealthFaq/index": 64,
	"./layouts/ehealthFaq/index.js": 64,
	"./layouts/ehealthPro": 65,
	"./layouts/ehealthPro/": 65,
	"./layouts/ehealthPro/index": 65,
	"./layouts/ehealthPro/index.js": 65,
	"./layouts/ehealthProAccMgmt": 66,
	"./layouts/ehealthProAccMgmt/": 66,
	"./layouts/ehealthProAccMgmt/index": 66,
	"./layouts/ehealthProAccMgmt/index.js": 66,
	"./layouts/ehealthProFaq": 67,
	"./layouts/ehealthProFaq/": 67,
	"./layouts/ehealthProFaq/index": 67,
	"./layouts/ehealthProFaq/index.js": 67,
	"./layouts/ehealthProInfoSharing": 68,
	"./layouts/ehealthProInfoSharing/": 68,
	"./layouts/ehealthProInfoSharing/index": 68,
	"./layouts/ehealthProInfoSharing/index.js": 68,
	"./layouts/ehealthProMiniAssistant": 69,
	"./layouts/ehealthProMiniAssistant/": 69,
	"./layouts/ehealthProMiniAssistant/index": 69,
	"./layouts/ehealthProMiniAssistant/index.js": 69,
	"./layouts/ehealthProNotiCenter": 70,
	"./layouts/ehealthProNotiCenter/": 70,
	"./layouts/ehealthProNotiCenter/index": 70,
	"./layouts/ehealthProNotiCenter/index.js": 70,
	"./layouts/elife/coins": 71,
	"./layouts/elife/coins/": 71,
	"./layouts/elife/coins/index": 71,
	"./layouts/elife/coins/index.js": 71,
	"./layouts/elife/elifeLeaderBoard": 72,
	"./layouts/elife/elifeLeaderBoard/": 72,
	"./layouts/elife/elifeLeaderBoard/index": 72,
	"./layouts/elife/elifeLeaderBoard/index.js": 72,
	"./layouts/elife/elifeParklist": 73,
	"./layouts/elife/elifeParklist/": 73,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined": 270,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined.json": 270,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined_removeceremony": 271,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined_removeceremony.json": 271,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined_withceremony": 272,
	"./layouts/elife/elifeParklist/data/20240116_0812_Go to Park Location list combined_withceremony.json": 272,
	"./layouts/elife/elifeParklist/data/parks": 194,
	"./layouts/elife/elifeParklist/data/parks.json": 194,
	"./layouts/elife/elifeParklist/index": 73,
	"./layouts/elife/elifeParklist/index.js": 73,
	"./layouts/elife/faq": 74,
	"./layouts/elife/faq/": 74,
	"./layouts/elife/faq/index": 74,
	"./layouts/elife/faq/index.js": 74,
	"./layouts/elife/overview": 75,
	"./layouts/elife/overview/": 75,
	"./layouts/elife/overview/index": 75,
	"./layouts/elife/overview/index.js": 75,
	"./layouts/elife/redemption": 76,
	"./layouts/elife/redemption/": 76,
	"./layouts/elife/redemption/index": 76,
	"./layouts/elife/redemption/index.js": 76,
	"./layouts/elife/stepChallenge": 141,
	"./layouts/elife/stepChallenge/": 141,
	"./layouts/elife/stepChallenge/index": 141,
	"./layouts/elife/stepChallenge/index.js": 141,
	"./layouts/elife/tutorial": 77,
	"./layouts/elife/tutorial/": 77,
	"./layouts/elife/tutorial/index": 77,
	"./layouts/elife/tutorial/index.js": 77,
	"./layouts/eppPrivacy": 78,
	"./layouts/eppPrivacy/": 78,
	"./layouts/eppPrivacy/index": 78,
	"./layouts/eppPrivacy/index.js": 78,
	"./layouts/healthManagement": 79,
	"./layouts/healthManagement/": 79,
	"./layouts/healthManagement/index": 79,
	"./layouts/healthManagement/index.js": 79,
	"./layouts/healthNews": 80,
	"./layouts/healthNews/": 80,
	"./layouts/healthNews/index": 80,
	"./layouts/healthNews/index.js": 80,
	"./layouts/healthProgram": 81,
	"./layouts/healthProgram/": 81,
	"./layouts/healthProgram/index": 81,
	"./layouts/healthProgram/index.js": 81,
	"./layouts/healthcareDocument": 110,
	"./layouts/healthcareDocument/": 110,
	"./layouts/healthcareDocument/index": 110,
	"./layouts/healthcareDocument/index.js": 110,
	"./layouts/maintenance": 82,
	"./layouts/maintenance/": 82,
	"./layouts/maintenance/index": 82,
	"./layouts/maintenance/index.js": 82,
	"./layouts/medicalCertificate": 111,
	"./layouts/medicalCertificate/": 111,
	"./layouts/medicalCertificate/index": 111,
	"./layouts/medicalCertificate/index.js": 111,
	"./layouts/myFamilyDoctor": 112,
	"./layouts/myFamilyDoctor/": 112,
	"./layouts/myFamilyDoctor/index": 112,
	"./layouts/myFamilyDoctor/index.js": 112,
	"./layouts/notFoundPage": 113,
	"./layouts/notFoundPage/": 113,
	"./layouts/notFoundPage/index": 113,
	"./layouts/notFoundPage/index.js": 113,
	"./layouts/personalFolder": 114,
	"./layouts/personalFolder/": 114,
	"./layouts/personalFolder/index": 114,
	"./layouts/personalFolder/index.js": 114,
	"./layouts/privacyGame": 115,
	"./layouts/privacyGame/": 115,
	"./layouts/privacyGame/GameCanvas": 150,
	"./layouts/privacyGame/GameCanvas.jsx": 150,
	"./layouts/privacyGame/index": 115,
	"./layouts/privacyGame/index.js": 115,
	"./layouts/privacyProtection": 83,
	"./layouts/privacyProtection/": 83,
	"./layouts/privacyProtection/index": 83,
	"./layouts/privacyProtection/index.js": 83,
	"./layouts/promotion": 43,
	"./layouts/promotion/": 43,
	"./layouts/promotion/BannerSlider": 154,
	"./layouts/promotion/BannerSlider.js": 154,
	"./layouts/promotion/FixedDownloadBar": 153,
	"./layouts/promotion/FixedDownloadBar.js": 153,
	"./layouts/promotion/PhoneAnimationSlider": 152,
	"./layouts/promotion/PhoneAnimationSlider.js": 152,
	"./layouts/promotion/index": 43,
	"./layouts/promotion/index.js": 43,
	"./layouts/promulgation": 84,
	"./layouts/promulgation/": 84,
	"./layouts/promulgation/BannerSlider": 155,
	"./layouts/promulgation/BannerSlider.js": 155,
	"./layouts/promulgation/index": 84,
	"./layouts/promulgation/index.js": 84,
	"./layouts/promulgation/promotionTruck": 85,
	"./layouts/promulgation/promotionTruck/": 85,
	"./layouts/promulgation/promotionTruck/BannerSlider": 198,
	"./layouts/promulgation/promotionTruck/BannerSlider.js": 198,
	"./layouts/promulgation/promotionTruck/Swiper": 156,
	"./layouts/promulgation/promotionTruck/Swiper.js": 156,
	"./layouts/promulgation/promotionTruck/index": 85,
	"./layouts/promulgation/promotionTruck/index.js": 85,
	"./layouts/promulgation/promotionalVideos": 86,
	"./layouts/promulgation/promotionalVideos/": 86,
	"./layouts/promulgation/promotionalVideos/index": 86,
	"./layouts/promulgation/promotionalVideos/index.js": 86,
	"./layouts/promulgation/promulgation-advertisement": 87,
	"./layouts/promulgation/promulgation-advertisement/": 87,
	"./layouts/promulgation/promulgation-advertisement/BannerSlider": 199,
	"./layouts/promulgation/promulgation-advertisement/BannerSlider.js": 199,
	"./layouts/promulgation/promulgation-advertisement/Swiper": 200,
	"./layouts/promulgation/promulgation-advertisement/Swiper.js": 200,
	"./layouts/promulgation/promulgation-advertisement/index": 87,
	"./layouts/promulgation/promulgation-advertisement/index.js": 87,
	"./layouts/promulgation/promulgation-animation": 88,
	"./layouts/promulgation/promulgation-animation/": 88,
	"./layouts/promulgation/promulgation-animation/BannerSlider": 201,
	"./layouts/promulgation/promulgation-animation/BannerSlider.js": 201,
	"./layouts/promulgation/promulgation-animation/Swiper": 202,
	"./layouts/promulgation/promulgation-animation/Swiper.js": 202,
	"./layouts/promulgation/promulgation-animation/index": 88,
	"./layouts/promulgation/promulgation-animation/index.js": 88,
	"./layouts/promulgation/promulgation-picture-book": 89,
	"./layouts/promulgation/promulgation-picture-book/": 89,
	"./layouts/promulgation/promulgation-picture-book/BannerSlider": 203,
	"./layouts/promulgation/promulgation-picture-book/BannerSlider.js": 203,
	"./layouts/promulgation/promulgation-picture-book/Swiper": 204,
	"./layouts/promulgation/promulgation-picture-book/Swiper.js": 204,
	"./layouts/promulgation/promulgation-picture-book/index": 89,
	"./layouts/promulgation/promulgation-picture-book/index.js": 89,
	"./layouts/promulgation/promulgation-support-station": 90,
	"./layouts/promulgation/promulgation-support-station/": 90,
	"./layouts/promulgation/promulgation-support-station/index": 90,
	"./layouts/promulgation/promulgation-support-station/index.js": 90,
	"./layouts/qrcodeScanner": 91,
	"./layouts/qrcodeScanner/": 91,
	"./layouts/qrcodeScanner/index": 91,
	"./layouts/qrcodeScanner/index.js": 91,
	"./layouts/termsOfUse": 92,
	"./layouts/termsOfUse/": 92,
	"./layouts/termsOfUse/index": 92,
	"./layouts/termsOfUse/index.js": 92,
	"./layouts/vaccineCalResult": 142,
	"./layouts/vaccineCalResult/": 142,
	"./layouts/vaccineCalResult/index": 142,
	"./layouts/vaccineCalResult/index.js": 142,
	"./layouts/vaccineCalResultChild": 143,
	"./layouts/vaccineCalResultChild/": 143,
	"./layouts/vaccineCalResultChild/index": 143,
	"./layouts/vaccineCalResultChild/index.js": 143,
	"./layouts/vaccineCalculator": 144,
	"./layouts/vaccineCalculator/": 144,
	"./layouts/vaccineCalculator/VaccinePicker": 157,
	"./layouts/vaccineCalculator/VaccinePicker.js": 157,
	"./layouts/vaccineCalculator/index": 144,
	"./layouts/vaccineCalculator/index.js": 144,
	"./layouts/whatsnew": 93,
	"./layouts/whatsnew/": 93,
	"./layouts/whatsnew/index": 93,
	"./layouts/whatsnew/index.js": 93,
	"./resources/apis/api": 193,
	"./resources/apis/api.json": 193,
	"./resources/audios/correct.mp3": 289,
	"./resources/audios/wrong.mp3": 288,
	"./resources/download/online_interactive_picture_book.pdf": 438,
	"./resources/fonts/Roboto-Bold.eot": 439,
	"./resources/fonts/Roboto-Bold.svg": 440,
	"./resources/fonts/Roboto-Bold.ttf": 441,
	"./resources/fonts/Roboto-Bold.woff": 442,
	"./resources/fonts/Roboto-Bold22.ttf": 443,
	"./resources/fonts/Roboto-Medium.eot": 444,
	"./resources/fonts/Roboto-Medium.svg": 445,
	"./resources/fonts/Roboto-Medium.ttf": 446,
	"./resources/fonts/Roboto-Medium.woff": 447,
	"./resources/fonts/Roboto-Medium22.ttf": 448,
	"./resources/fonts/Roboto-Regular.eot": 449,
	"./resources/fonts/Roboto-Regular.svg": 450,
	"./resources/fonts/Roboto-Regular.ttf": 451,
	"./resources/fonts/Roboto-Regular.woff": 452,
	"./resources/fonts/Roboto-Regular22.ttf": 453,
	"./resources/fonts/SourceHanSansCN-Medium.eot": 454,
	"./resources/fonts/SourceHanSansCN-Medium.svg": 455,
	"./resources/fonts/SourceHanSansCN-Medium.ttf": 456,
	"./resources/fonts/SourceHanSansCN-Medium.woff": 457,
	"./resources/fonts/SourceHanSansCN-Normal.eot": 458,
	"./resources/fonts/SourceHanSansCN-Normal.svg": 459,
	"./resources/fonts/SourceHanSansCN-Normal.ttf": 460,
	"./resources/fonts/SourceHanSansCN-Normal.woff": 461,
	"./resources/fonts/glyphicons-halflings-regular.eot": 462,
	"./resources/fonts/glyphicons-halflings-regular.svg": 463,
	"./resources/fonts/glyphicons-halflings-regular.ttf": 464,
	"./resources/fonts/glyphicons-halflings-regular.woff": 465,
	"./resources/images/2medical_cert-bg.png": 466,
	"./resources/images/add-family-input-info-icon.png": 467,
	"./resources/images/add-family-scan-code-icon.png": 468,
	"./resources/images/add-family-title-deco.png": 469,
	"./resources/images/adolescent_top_bg.png": 470,
	"./resources/images/adr_icon.png": 471,
	"./resources/images/allergy_home_icon.png": 472,
	"./resources/images/allergy_p1_1.png": 473,
	"./resources/images/allergy_p1_3.png": 474,
	"./resources/images/allergy_p2_1.png": 475,
	"./resources/images/allergy_p2_2.png": 476,
	"./resources/images/allergy_p2_3.png": 477,
	"./resources/images/animate_arrow.png": 478,
	"./resources/images/appointment_icon.png": 479,
	"./resources/images/appointment_p1_2.png": 480,
	"./resources/images/appointment_p2_2.png": 481,
	"./resources/images/appointment_p2_3.png": 482,
	"./resources/images/appointment_p3_1.png": 483,
	"./resources/images/appointment_p3_3.png": 484,
	"./resources/images/appointment_p4_2.png": 485,
	"./resources/images/appointment_p4_3.png": 486,
	"./resources/images/appt-service-img.png": 487,
	"./resources/images/arrow-down.png": 488,
	"./resources/images/arrow-up.png": 489,
	"./resources/images/background-circle.png": 490,
	"./resources/images/backup-clinical-allergy-bg.png": 491,
	"./resources/images/banner_bg.png": 492,
	"./resources/images/banner_icon.png": 493,
	"./resources/images/birth-cert-reminder-icon.png": 494,
	"./resources/images/blank.png": 495,
	"./resources/images/bottom_bg.png": 496,
	"./resources/images/calculator-allow-text-edited.png": 497,
	"./resources/images/calculator-allow-text.png": 498,
	"./resources/images/calculator-bg.png": 499,
	"./resources/images/calculator-date-picker-icon.png": 500,
	"./resources/images/calculator-decoration1.png": 501,
	"./resources/images/calculator-decoration2.png": 502,
	"./resources/images/calculator-decoration3.png": 503,
	"./resources/images/calculator-dropdown-arrow-active.png": 504,
	"./resources/images/calculator-dropdown-arrow.png": 505,
	"./resources/images/calculator-men.png": 506,
	"./resources/images/calculator-not-allow-text.png": 507,
	"./resources/images/calculator-result-all-pass.png": 508,
	"./resources/images/calculator-result-allow.png": 509,
	"./resources/images/calculator-result-doctor-button.png": 510,
	"./resources/images/calculator-result-not-allow.png": 511,
	"./resources/images/calculator-result-vaccine-button.png": 512,
	"./resources/images/calculator-result-website-button.png": 513,
	"./resources/images/calculator-title-character.png": 514,
	"./resources/images/caregiver-bg.png": 515,
	"./resources/images/caregiver_p1_2.png": 516,
	"./resources/images/caregiver_p1_3.png": 517,
	"./resources/images/caregiver_p2_2.png": 518,
	"./resources/images/caregiver_p2_3.png": 519,
	"./resources/images/caregiver_p3_1.png": 520,
	"./resources/images/caregiver_p3_2.png": 521,
	"./resources/images/caregiver_p3_3.png": 522,
	"./resources/images/cbhr-bg.png": 523,
	"./resources/images/child_p1_1.png": 524,
	"./resources/images/child_p1_2.png": 525,
	"./resources/images/child_p2_1.png": 526,
	"./resources/images/child_p2_2.png": 527,
	"./resources/images/child_p3_1.png": 528,
	"./resources/images/child_p3_2.png": 529,
	"./resources/images/child_usage3.png": 530,
	"./resources/images/child_usage3_bg.png": 531,
	"./resources/images/childgrowth-bg.png": 532,
	"./resources/images/clinical-allergy-bg.png": 533,
	"./resources/images/clinical-appointment-bg.png": 534,
	"./resources/images/clinical-investigation-bg.png": 535,
	"./resources/images/clinical-medication-bg.png": 536,
	"./resources/images/clinical-vaccine-bg.png": 537,
	"./resources/images/close-qr.png": 538,
	"./resources/images/collapse-button-open.png": 539,
	"./resources/images/collapse-button.png": 540,
	"./resources/images/contact_phone.png": 541,
	"./resources/images/covid19-adolescent-top-banner.png": 542,
	"./resources/images/covid19-inapp-icon.png": 543,
	"./resources/images/covid19-popup/covid19-popup-en-desktop.png": 544,
	"./resources/images/covid19-popup/covid19-popup-en-mobile.png": 545,
	"./resources/images/covid19-popup/covid19-popup-zh-CN-desktop.png": 546,
	"./resources/images/covid19-popup/covid19-popup-zh-CN-mobile.png": 547,
	"./resources/images/covid19-popup/covid19-popup-zh-HK-desktop.png": 548,
	"./resources/images/covid19-popup/covid19-popup-zh-HK-mobile.png": 549,
	"./resources/images/covid19-popup/knowmore-btn-en.png": 550,
	"./resources/images/covid19-popup/knowmore-btn-shadow.png": 551,
	"./resources/images/covid19-popup/knowmore-btn-zh-CN.png": 552,
	"./resources/images/covid19-popup/knowmore-btn-zh-HK.png": 553,
	"./resources/images/covid19-popup/popup-close-desktop.png": 554,
	"./resources/images/covid19-popup/popup-close-mobile.png": 555,
	"./resources/images/covid19-qr-top-banner.png": 556,
	"./resources/images/covid_adolescent_p1_2.png": 557,
	"./resources/images/covid_adolescent_p2_2.png": 558,
	"./resources/images/covid_adolescent_p3_1.png": 559,
	"./resources/images/covid_adolescent_p3_2.png": 560,
	"./resources/images/covid_adolescent_p4_1.png": 561,
	"./resources/images/covid_adolescent_p4_2.png": 562,
	"./resources/images/covid_adolescent_p5_1.png": 563,
	"./resources/images/covid_qr_export_3.png": 564,
	"./resources/images/covid_qr_indicate_3.png": 565,
	"./resources/images/covid_qr_indicate_empty.png": 566,
	"./resources/images/covid_qr_p1_empty.png": 567,
	"./resources/images/covid_qr_p2_1_empty_mobile.png": 568,
	"./resources/images/covid_qr_p2_empty.png": 569,
	"./resources/images/covid_qr_p3_2.png": 570,
	"./resources/images/covid_qr_p3_2_mobile.png": 571,
	"./resources/images/covid_qr_p3_3.png": 572,
	"./resources/images/covid_qr_p3_3_mobile.png": 573,
	"./resources/images/covid_qr_p3_empty.png": 574,
	"./resources/images/covid_qr_p4_empty.png": 575,
	"./resources/images/disclaimer-popup/ehealth-red-popup-desktop-1.0.png": 576,
	"./resources/images/disclaimer-popup/ehealth-red-popup-desktop.png": 577,
	"./resources/images/disclaimer-popup/ehealth-red-popup-mobile.png": 578,
	"./resources/images/disclaimer-popup/ok-button-en.png": 579,
	"./resources/images/disclaimer-popup/ok-button-shadow.png": 580,
	"./resources/images/disclaimer-popup/ok-button-zh-CN.png": 581,
	"./resources/images/disclaimer-popup/ok-button-zh-HK.png": 582,
	"./resources/images/doctor-search-bg.png": 583,
	"./resources/images/doctor-search_p1_2.png": 584,
	"./resources/images/doctor-search_p2_3.png": 585,
	"./resources/images/doctor-search_p3_2.png": 586,
	"./resources/images/doctor-search_p3_3.png": 587,
	"./resources/images/doctor-search_p4_1.png": 588,
	"./resources/images/doctor-search_p4_3.png": 589,
	"./resources/images/doctor_icon.png": 590,
	"./resources/images/download-apk-mobile-qrcode.png": 591,
	"./resources/images/download-banner-bg.jpg": 592,
	"./resources/images/download-girl-graphic.png": 593,
	"./resources/images/download-item/75a-2024/2024_National Day-sticker.ai": 594,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-01.png": 595,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-02.png": 596,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-03.png": 597,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-04.png": 598,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-05.png": 599,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-06.png": 600,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-07.png": 601,
	"./resources/images/download-item/75a-2024/75a-the-founding-of-prc-08.png": 602,
	"./resources/images/download-item/background/ehealth-bg1-16-9.jpg": 205,
	"./resources/images/download-item/background/ehealth-bg1-4-3.jpg": 206,
	"./resources/images/download-item/background/ehealth-bg1-mobile.jpg": 207,
	"./resources/images/download-item/background/ehealth-bg1-preview.jpg": 603,
	"./resources/images/download-item/background/ehealth-bg2-16-9.jpg": 208,
	"./resources/images/download-item/background/ehealth-bg2-4-3.jpg": 209,
	"./resources/images/download-item/background/ehealth-bg2-mobile.jpg": 210,
	"./resources/images/download-item/background/ehealth-bg2-preview.jpg": 604,
	"./resources/images/download-item/background/ehealth-bg3-16-9.jpg": 211,
	"./resources/images/download-item/background/ehealth-bg3-4-3.jpg": 212,
	"./resources/images/download-item/background/ehealth-bg3-mobile.jpg": 213,
	"./resources/images/download-item/background/ehealth-bg3-preview.jpg": 605,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-1.gif": 606,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-2.gif": 607,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-3.gif": 608,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-4.gif": 609,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-5.gif": 610,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-6.gif": 611,
	"./resources/images/download-item/bpbg-set-2022/bpbg-2022-7.gif": 612,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-1.gif": 613,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-2.gif": 614,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-3.gif": 615,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-4.gif": 616,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-5.gif": 617,
	"./resources/images/download-item/cny-set-2023/cny-set-2023-6.gif": 618,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-1.webp": 619,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-2.webp": 620,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-3.webp": 621,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-4.webp": 622,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-5.webp": 623,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-6.webp": 624,
	"./resources/images/download-item/daily-life-2023/daily-life-2023-7.webp": 625,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-1.gif": 626,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-10.gif": 627,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-11.gif": 628,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-12.gif": 629,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-13.gif": 630,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-2.gif": 631,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-3.gif": 632,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-4.gif": 633,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-5.gif": 634,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-6.gif": 635,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-7.gif": 636,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-8.gif": 637,
	"./resources/images/download-item/elife-school-2024/elife-school-2024-9.gif": 638,
	"./resources/images/download-item/health-management-2023/health-management-2023-1.webp": 639,
	"./resources/images/download-item/health-management-2023/health-management-2023-2.webp": 640,
	"./resources/images/download-item/health-management-2023/health-management-2023-3.webp": 641,
	"./resources/images/download-item/health-management-2023/health-management-2023-4.webp": 642,
	"./resources/images/download-item/health-management-2023/health-management-2023-5.webp": 643,
	"./resources/images/download-item/health-management-2023/health-management-2023-6.webp": 644,
	"./resources/images/download-item/health-management-2023/health-management-2023-7.webp": 645,
	"./resources/images/download-item/privacy-2023/privacy-2023-1.webp": 646,
	"./resources/images/download-item/privacy-2023/privacy-2023-2.webp": 647,
	"./resources/images/download-item/privacy-2023/privacy-2023-3.webp": 648,
	"./resources/images/download-item/privacy-2023/privacy-2023-4.webp": 649,
	"./resources/images/download-item/privacy-2023/privacy-2023-5.webp": 650,
	"./resources/images/download-item/privacy-2023/privacy-2023-6.webp": 651,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-1.gif": 652,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-2.gif": 653,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-3.gif": 654,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-4.gif": 655,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-5.gif": 656,
	"./resources/images/download-item/xmas-set-2022/xmas-set-2022-6.gif": 657,
	"./resources/images/download-mama-graphic.png": 658,
	"./resources/images/ehealth-pro-bg.png": 659,
	"./resources/images/ehealth-pro/background-circle-pro.jpg": 660,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p1_1.png": 661,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p1_2.png": 662,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p1_3.png": 663,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p2_1.png": 664,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p2_2.png": 665,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p3_1.png": 666,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p3_2.png": 667,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p4_1.png": 668,
	"./resources/images/ehealth-pro/ehealth_pro_acc_p4_2.png": 669,
	"./resources/images/ehealth-pro/ehealth_pro_acc_request_access_step_1.png": 670,
	"./resources/images/ehealth-pro/ehealth_pro_acc_request_access_step_2.png": 671,
	"./resources/images/ehealth-pro/ehealth_pro_acc_request_access_step_3.png": 672,
	"./resources/images/ehealth-pro/ehealth_pro_acc_request_access_step_4.png": 673,
	"./resources/images/ehealth-pro/ehealth_pro_activiate_step_1.png": 674,
	"./resources/images/ehealth-pro/ehealth_pro_activiate_step_2.png": 675,
	"./resources/images/ehealth-pro/ehealth_pro_activiate_step_3.png": 676,
	"./resources/images/ehealth-pro/ehealth_pro_activiate_step_4.png": 677,
	"./resources/images/ehealth-pro/ehealth_pro_faq_graphic_1.png": 678,
	"./resources/images/ehealth-pro/ehealth_pro_feature_1.png": 679,
	"./resources/images/ehealth-pro/ehealth_pro_feature_2.png": 680,
	"./resources/images/ehealth-pro/ehealth_pro_feature_3.png": 681,
	"./resources/images/ehealth-pro/ehealth_pro_info_share_p1_1.png": 682,
	"./resources/images/ehealth-pro/ehealth_pro_info_share_p1_2.png": 683,
	"./resources/images/ehealth-pro/ehealth_pro_info_share_p2_1.png": 684,
	"./resources/images/ehealth-pro/ehealth_pro_info_share_p2_2.png": 685,
	"./resources/images/ehealth-pro/ehealth_pro_mini_assistant_p1_1.png": 686,
	"./resources/images/ehealth-pro/ehealth_pro_mini_assistant_p1_2.png": 687,
	"./resources/images/ehealth-pro/ehealth_pro_noti_center_p1_1.png": 688,
	"./resources/images/ehealth-pro/ehealth_pro_noti_center_p1_2.png": 689,
	"./resources/images/ehealth-pro/ehealth_pro_noti_center_p2_1.png": 690,
	"./resources/images/ehealth-pro/ehealth_pro_noti_center_p2_2.png": 691,
	"./resources/images/ehealth-pro/ehealth_pro_noti_tips_step_1.png": 692,
	"./resources/images/ehealth-pro/ehealth_pro_noti_tips_step_2.png": 693,
	"./resources/images/ehealth-pro/ehealth_pro_noti_tips_step_3.png": 694,
	"./resources/images/ehealth-pro/ehealth_pro_p1_1.png": 695,
	"./resources/images/ehealth-pro/ehealth_pro_p1_2.png": 696,
	"./resources/images/ehealth-pro/ehealth_pro_p2_1.png": 697,
	"./resources/images/ehealth-pro/ehealth_pro_p2_2.png": 698,
	"./resources/images/ehealth-pro/ehealth_pro_p3_1.png": 699,
	"./resources/images/ehealth-pro/ehealth_pro_p3_2.png": 700,
	"./resources/images/ehealth-pro/ehealthpro_faq-banner-bg.jpg": 701,
	"./resources/images/ehealth-pro/pro-noti-center-tips.png": 702,
	"./resources/images/ehealth-pro/step-horizontal-arrow.png": 703,
	"./resources/images/ehealthpro_slider_phone1.png": 704,
	"./resources/images/elife-leaderboard/badge-1.png": 705,
	"./resources/images/elife-leaderboard/badge-2.png": 706,
	"./resources/images/elife-leaderboard/badge-3.png": 707,
	"./resources/images/elife-leaderboard/deco-cloud.png": 708,
	"./resources/images/elife-leaderboard/footer-desktop.png": 709,
	"./resources/images/elife-leaderboard/footer-mobile.png": 710,
	"./resources/images/elife-leaderboard/hero-bg-desktop.png": 711,
	"./resources/images/elife-leaderboard/hero-bg-mobile.png": 712,
	"./resources/images/elife-leaderboard/hero-title-en.png": 713,
	"./resources/images/elife-leaderboard/hero-title-zh-CN.png": 714,
	"./resources/images/elife-leaderboard/hero-title-zh-HK.png": 715,
	"./resources/images/elife-leaderboard/ranking-bg.png": 716,
	"./resources/images/elife-leaderboard/ranking-header.png": 717,
	"./resources/images/elife-parklist/footer-desktop.png": 718,
	"./resources/images/elife-parklist/footer-mobile.png": 719,
	"./resources/images/elife-parklist/hero-bg-desktop.png": 720,
	"./resources/images/elife-parklist/hero-bg-mobile.png": 721,
	"./resources/images/elife-parklist/hero-title-en.png": 722,
	"./resources/images/elife-parklist/hero-title-zh-CN.png": 723,
	"./resources/images/elife-parklist/hero-title-zh-HK.png": 724,
	"./resources/images/elife-parklist/ico-clear.png": 725,
	"./resources/images/elife-parklist/ico-cloud.png": 726,
	"./resources/images/elife-parklist/ico-search.png": 727,
	"./resources/images/elife/10000steps-main-img.png": 728,
	"./resources/images/elife/coins-intro.png": 729,
	"./resources/images/elife/elife-coins-gadgets-item.png": 730,
	"./resources/images/elife/elife-coins-tier1.png": 731,
	"./resources/images/elife/elife-coins-tier2.png": 732,
	"./resources/images/elife/elife-coins-tier3.png": 733,
	"./resources/images/elife/en/e-wonderland-logo.png": 734,
	"./resources/images/elife/en/life-earn-point-banner-desktop.jpg": 735,
	"./resources/images/elife/en/life-earn-point-banner-mobile.jpg": 736,
	"./resources/images/elife/en/life-faq-banner-graphic.png": 737,
	"./resources/images/elife/en/life-leader-board-banner-desktop.jpg": 738,
	"./resources/images/elife/en/life-leader-board-banner-mobile.jpg": 739,
	"./resources/images/elife/en/life-overview-banner-desktop.jpg": 740,
	"./resources/images/elife/en/life-overview-banner-mobile.jpg": 741,
	"./resources/images/elife/en/life-park-list-banner-desktop.jpg": 742,
	"./resources/images/elife/en/life-park-list-banner-mobile.jpg": 743,
	"./resources/images/elife/en/life-redemption-banner-desktop.jpg": 744,
	"./resources/images/elife/en/life-redemption-banner-graphic.png": 745,
	"./resources/images/elife/en/life-redemption-banner-mobile.jpg": 746,
	"./resources/images/elife/en/life-tutorial-banner-graphic.png": 747,
	"./resources/images/elife/en/life-tutorial-download-phone.jpg": 748,
	"./resources/images/elife/en/step-challenge-banner-desktop.jpg": 749,
	"./resources/images/elife/gift/redemption-gift-bag.png": 750,
	"./resources/images/elife/gift/redemption-gift-cutlery-set.png": 751,
	"./resources/images/elife/gift/redemption-gift-picnic-mat.png": 752,
	"./resources/images/elife/gift/redemption-gift-pouch.png": 753,
	"./resources/images/elife/gift/redemption-gift-soft-tape.png": 754,
	"./resources/images/elife/gift/redemption-gift-towel.png": 755,
	"./resources/images/elife/individual-enrolment-img.png": 756,
	"./resources/images/elife/life-overview-park-intro1.png": 757,
	"./resources/images/elife/life-overview-park-intro2.png": 758,
	"./resources/images/elife/life-overview-park-intro3.png": 759,
	"./resources/images/elife/life-redemption-gift-preview.jpg": 760,
	"./resources/images/elife/life-redemption-main-graphic.png": 761,
	"./resources/images/elife/life-tutorial-download-qr.jpg": 762,
	"./resources/images/elife/step-accordion-icon-cert.png": 763,
	"./resources/images/elife/step-accordion-icon-coin.png": 764,
	"./resources/images/elife/step-accordion-icon-friend.png": 765,
	"./resources/images/elife/step-accordion-icon-step.png": 766,
	"./resources/images/elife/step-challenge-challenge-period.png": 767,
	"./resources/images/elife/step-challenge-enrol-period.png": 768,
	"./resources/images/elife/step-challenge-intro.png": 769,
	"./resources/images/elife/title-lion-deco.png": 770,
	"./resources/images/elife/wonderland-ball.png": 771,
	"./resources/images/elife/wonderland-coin.png": 772,
	"./resources/images/elife/wonderland-family-graphic.png": 773,
	"./resources/images/elife/workplace-enrolment-img.png": 774,
	"./resources/images/elife/zh-CN/e-wonderland-logo.png": 775,
	"./resources/images/elife/zh-CN/life-earn-point-banner-desktop.jpg": 776,
	"./resources/images/elife/zh-CN/life-earn-point-banner-mobile.jpg": 777,
	"./resources/images/elife/zh-CN/life-leader-board-banner-desktop.jpg": 778,
	"./resources/images/elife/zh-CN/life-leader-board-banner-mobile.jpg": 779,
	"./resources/images/elife/zh-CN/life-overview-banner-desktop.jpg": 780,
	"./resources/images/elife/zh-CN/life-overview-banner-mobile.jpg": 781,
	"./resources/images/elife/zh-CN/life-park-list-banner-desktop.jpg": 782,
	"./resources/images/elife/zh-CN/life-park-list-banner-mobile.jpg": 783,
	"./resources/images/elife/zh-CN/life-redemption-banner-desktop.jpg": 784,
	"./resources/images/elife/zh-CN/life-redemption-banner-mobile.jpg": 785,
	"./resources/images/elife/zh-CN/life-tutorial-banner-graphic.png": 786,
	"./resources/images/elife/zh-CN/life-tutorial-download-phone.jpg": 787,
	"./resources/images/elife/zh-CN/step-challenge-banner-desktop.jpg": 788,
	"./resources/images/elife/zh-HK/e-wonderland-logo.png": 789,
	"./resources/images/elife/zh-HK/life-earn-point-banner-desktop.jpg": 790,
	"./resources/images/elife/zh-HK/life-earn-point-banner-mobile.jpg": 791,
	"./resources/images/elife/zh-HK/life-leader-board-banner-desktop.jpg": 792,
	"./resources/images/elife/zh-HK/life-leader-board-banner-mobile.jpg": 793,
	"./resources/images/elife/zh-HK/life-overview-banner-desktop.jpg": 794,
	"./resources/images/elife/zh-HK/life-overview-banner-mobile.jpg": 795,
	"./resources/images/elife/zh-HK/life-park-list-banner-desktop.jpg": 796,
	"./resources/images/elife/zh-HK/life-park-list-banner-mobile.jpg": 797,
	"./resources/images/elife/zh-HK/life-redemption-banner-desktop.jpg": 798,
	"./resources/images/elife/zh-HK/life-redemption-banner-graphic.png": 799,
	"./resources/images/elife/zh-HK/life-redemption-banner-mobile.jpg": 800,
	"./resources/images/elife/zh-HK/life-tutorial-banner-graphic.png": 801,
	"./resources/images/elife/zh-HK/life-tutorial-download-phone.jpg": 802,
	"./resources/images/elife/zh-HK/step-challenge-banner-desktop.jpg": 803,
	"./resources/images/empty.png": 804,
	"./resources/images/en/01_news.png": 805,
	"./resources/images/en/02_doctor.png": 806,
	"./resources/images/en/03_growth.png": 807,
	"./resources/images/en/04_appointment.png": 808,
	"./resources/images/en/05_allergy.png": 809,
	"./resources/images/en/06_voucher.png": 810,
	"./resources/images/en/07_caregiver.png": 811,
	"./resources/images/en/08_family.png": 812,
	"./resources/images/en/16-above-input-info-1.png": 813,
	"./resources/images/en/16-above-input-info-2.png": 814,
	"./resources/images/en/16-above-scan-1.png": 815,
	"./resources/images/en/16-above-scan-2.png": 816,
	"./resources/images/en/Frame_1.png": 817,
	"./resources/images/en/QR-baby-mobile.png": 818,
	"./resources/images/en/allergy_p1_2.png": 819,
	"./resources/images/en/allergy_p2_1.png": 820,
	"./resources/images/en/allergy_slider_phone1.png": 821,
	"./resources/images/en/allergy_slider_phone2.png": 822,
	"./resources/images/en/allergy_slider_phone3.png": 823,
	"./resources/images/en/apk-dl-btn.png": 824,
	"./resources/images/en/app_store.png": 825,
	"./resources/images/en/appointment_p1_1.png": 826,
	"./resources/images/en/appointment_p2_1.png": 827,
	"./resources/images/en/appointment_p3_1.png": 828,
	"./resources/images/en/appointment_p3_2.png": 829,
	"./resources/images/en/appointment_p4_1.png": 830,
	"./resources/images/en/appointment_slider_phone1-1.png": 831,
	"./resources/images/en/appointment_slider_phone1.png": 832,
	"./resources/images/en/appointment_slider_phone2.png": 833,
	"./resources/images/en/appointment_slider_phone3.png": 834,
	"./resources/images/en/banner_record.png": 835,
	"./resources/images/en/banner_record_bg.png": 836,
	"./resources/images/en/birth-cert-step1.png": 837,
	"./resources/images/en/birth-cert-step2.png": 838,
	"./resources/images/en/birth-cert-step3.png": 839,
	"./resources/images/en/birth-cert-step4.png": 840,
	"./resources/images/en/bk-download_phone.png": 841,
	"./resources/images/en/calculator-result-under-age-12.png": 842,
	"./resources/images/en/calculator-result-under-age-5.jpg": 843,
	"./resources/images/en/caregiver_p1_1.png": 844,
	"./resources/images/en/caregiver_p2_1.png": 845,
	"./resources/images/en/caregiver_p3_1.png": 846,
	"./resources/images/en/caregiver_slider_phone1.png": 847,
	"./resources/images/en/caregiver_slider_phone2.png": 848,
	"./resources/images/en/caregiver_slider_phone3.png": 849,
	"./resources/images/en/caregiver_tip_1.png": 850,
	"./resources/images/en/cbhr_slider_phone1.png": 851,
	"./resources/images/en/child_p1.png": 852,
	"./resources/images/en/child_p1_1.png": 853,
	"./resources/images/en/child_p2.png": 854,
	"./resources/images/en/child_p3.png": 855,
	"./resources/images/en/child_usage0.png": 856,
	"./resources/images/en/child_usage1.png": 857,
	"./resources/images/en/child_usage2.png": 858,
	"./resources/images/en/covid19-adolescent-top-banner.png": 859,
	"./resources/images/en/covid_adolescent_p1_1.png": 860,
	"./resources/images/en/covid_adolescent_p2_1.png": 861,
	"./resources/images/en/covid_adolescent_p4_1.png": 862,
	"./resources/images/en/covid_adolescent_p4_2.png": 863,
	"./resources/images/en/covid_adolescent_p5_1.png": 864,
	"./resources/images/en/covid_qr_export_1.png": 865,
	"./resources/images/en/covid_qr_export_2.png": 866,
	"./resources/images/en/covid_qr_indicate_1-1.gif": 867,
	"./resources/images/en/covid_qr_indicate_2-1.gif": 868,
	"./resources/images/en/covid_qr_p0.png": 869,
	"./resources/images/en/covid_qr_p1_1.png": 870,
	"./resources/images/en/covid_qr_p1_1_mobile.png": 871,
	"./resources/images/en/covid_qr_p1_2.png": 872,
	"./resources/images/en/covid_qr_p1_2_mobile.png": 873,
	"./resources/images/en/covid_qr_p1_3.png": 874,
	"./resources/images/en/covid_qr_p2_1.gif": 875,
	"./resources/images/en/covid_qr_p2_1.png": 876,
	"./resources/images/en/covid_qr_p2_1_mobile.gif": 877,
	"./resources/images/en/covid_qr_p2_1_mobile.png": 878,
	"./resources/images/en/covid_qr_p2_2.png": 879,
	"./resources/images/en/covid_qr_p2_2_mobile.png": 880,
	"./resources/images/en/covid_qr_p2_3.png": 881,
	"./resources/images/en/covid_qr_p3_1.png": 882,
	"./resources/images/en/covid_qr_p3_1_mobile.png": 883,
	"./resources/images/en/covid_qr_p4_1.png": 884,
	"./resources/images/en/covid_qr_p4_2.png": 885,
	"./resources/images/en/desktop.ini": 886,
	"./resources/images/en/doctor-search_p1_1.png": 887,
	"./resources/images/en/doctor-search_p1_3.png": 888,
	"./resources/images/en/doctor-search_p2_1.png": 889,
	"./resources/images/en/doctor-search_p2_2.png": 890,
	"./resources/images/en/doctor-search_p3_1.png": 891,
	"./resources/images/en/doctor-search_p4_2.png": 892,
	"./resources/images/en/download-apk-phone.png": 893,
	"./resources/images/en/download-bg-banner-graphic.png": 894,
	"./resources/images/en/download-sticker-banner-graphic.png": 895,
	"./resources/images/en/download_phone.png": 896,
	"./resources/images/en/ehealth_50x_coins_banner_desktop.jpg": 897,
	"./resources/images/en/ehealth_50x_coins_banner_desktop@3x.png": 898,
	"./resources/images/en/ehealth_50x_coins_banner_mobile.jpg": 899,
	"./resources/images/en/ehealth_adolescent_banner_desktop.png": 900,
	"./resources/images/en/ehealth_adolescent_banner_mobile.png": 901,
	"./resources/images/en/ehealth_bpbg_banner_desktop.jpg": 902,
	"./resources/images/en/ehealth_bpbg_banner_mobile.jpg": 903,
	"./resources/images/en/ehealth_calculator_banner_desktop.jpg": 904,
	"./resources/images/en/ehealth_calculator_banner_desktop.png": 905,
	"./resources/images/en/ehealth_calculator_banner_mobile.jpg": 906,
	"./resources/images/en/ehealth_calculator_banner_mobile.png": 907,
	"./resources/images/en/ehealth_cbhr_banner_desktop.jpg": 908,
	"./resources/images/en/ehealth_cbhr_banner_mobile.jpg": 909,
	"./resources/images/en/ehealth_dental_banner_desktop.jpg": 910,
	"./resources/images/en/ehealth_dental_banner_mobile.jpg": 911,
	"./resources/images/en/ehealth_ehr_lite_banner_desktop.jpg": 912,
	"./resources/images/en/ehealth_ehr_lite_banner_mobile.jpg": 913,
	"./resources/images/en/ehealth_health_coins_redemption_banner_desktop.jpg": 914,
	"./resources/images/en/ehealth_health_coins_redemption_banner_mobile.jpg": 915,
	"./resources/images/en/ehealth_lab_record_banner_desktop.jpg": 916,
	"./resources/images/en/ehealth_lab_record_banner_mobile.jpg": 917,
	"./resources/images/en/ehealth_latest_news_banner_desktop.jpg": 918,
	"./resources/images/en/ehealth_latest_news_banner_mobile.jpg": 919,
	"./resources/images/en/ehealth_minor_redemption_banner_desktop.jpg": 920,
	"./resources/images/en/ehealth_minor_redemption_banner_mobile.jpg": 921,
	"./resources/images/en/ehealth_minor_reg_banner_desktop.jpg": 922,
	"./resources/images/en/ehealth_minor_reg_banner_mobile.jpg": 923,
	"./resources/images/en/ehealth_personal_folder_banner_desktop.jpg": 924,
	"./resources/images/en/ehealth_personal_folder_banner_mobile.jpg": 925,
	"./resources/images/en/ehealth_radi_record_banner_desktop.jpg": 926,
	"./resources/images/en/ehealth_radi_record_banner_mobile.jpg": 927,
	"./resources/images/en/ehealth_survey_banner_desktop.png": 928,
	"./resources/images/en/ehealth_survey_banner_mobile.png": 929,
	"./resources/images/en/ehealth_website_banner_desktop.jpg": 930,
	"./resources/images/en/ehealth_website_banner_mobile.jpg": 931,
	"./resources/images/en/ehealthpro_acc_mgmt_slider_phone1.png": 932,
	"./resources/images/en/ehealthpro_faq-banner-graphic.png": 933,
	"./resources/images/en/ehealthpro_info_share_slider_phone1.png": 934,
	"./resources/images/en/ehealthpro_mini_assistant_slider_phone1.png": 935,
	"./resources/images/en/ehealthpro_noti_center_slider_phone1.png": 936,
	"./resources/images/en/ehealthpro_noti_center_slider_phone2.png": 937,
	"./resources/images/en/ehealthpro_slider_phone1.png": 938,
	"./resources/images/en/faq-banner-graphic.png": 939,
	"./resources/images/en/google_play.png": 940,
	"./resources/images/en/health-management_p1_1.png": 941,
	"./resources/images/en/health-management_p2_1.png": 942,
	"./resources/images/en/health-management_p3_1.png": 943,
	"./resources/images/en/health-management_p3_2.png": 944,
	"./resources/images/en/health-management_p4_1.png": 945,
	"./resources/images/en/health-program_cb_1.png": 946,
	"./resources/images/en/health-program_p0_1.png": 947,
	"./resources/images/en/health-program_p0_2.png": 948,
	"./resources/images/en/health-program_p1_1.png": 949,
	"./resources/images/en/health-program_p1_2.png": 950,
	"./resources/images/en/health-program_p2_2.png": 951,
	"./resources/images/en/health-program_p3_1.png": 952,
	"./resources/images/en/health-program_p3_2.png": 953,
	"./resources/images/en/health-program_p4_1.png": 954,
	"./resources/images/en/health-program_p4_3.png": 955,
	"./resources/images/en/healthcare_doc_p1_1.png": 956,
	"./resources/images/en/healthcare_doc_slider_phone1.png": 957,
	"./resources/images/en/healthcare_doc_slider_phone2.png": 958,
	"./resources/images/en/healthcare_doc_slider_phone3.png": 959,
	"./resources/images/en/home_allergy.png": 960,
	"./resources/images/en/home_appointments.png": 961,
	"./resources/images/en/home_caregiver.png": 962,
	"./resources/images/en/home_cbhr.png": 963,
	"./resources/images/en/home_family_doctor.png": 964,
	"./resources/images/en/home_health_news.png": 965,
	"./resources/images/en/home_health_programme.png": 966,
	"./resources/images/en/home_healthcare_document.png": 967,
	"./resources/images/en/home_investigation.png": 968,
	"./resources/images/en/home_investigations.png": 969,
	"./resources/images/en/home_medical_certificate.png": 970,
	"./resources/images/en/home_medical_certificate_icon.png": 971,
	"./resources/images/en/home_medication.png": 972,
	"./resources/images/en/home_personal_folder.png": 973,
	"./resources/images/en/home_vaccine.png": 974,
	"./resources/images/en/huawei.png": 975,
	"./resources/images/en/img_growth.png": 976,
	"./resources/images/en/investigation_p1_1.png": 977,
	"./resources/images/en/investigation_p2_1.png": 978,
	"./resources/images/en/investigation_radi_1.png": 979,
	"./resources/images/en/investigation_slider_phone1.png": 980,
	"./resources/images/en/investigation_slider_phone2.png": 981,
	"./resources/images/en/investigation_slider_phone3.png": 982,
	"./resources/images/en/land-elife-banner-img-mobile.jpg": 983,
	"./resources/images/en/land-elife-banner-img.jpg": 984,
	"./resources/images/en/land-scanner-banner-img-mobile.jpg": 985,
	"./resources/images/en/land-scanner-banner-img.jpg": 986,
	"./resources/images/en/landing-health-management-phone.png": 987,
	"./resources/images/en/landing-slider-img-1-mobile.jpg": 988,
	"./resources/images/en/landing-slider-img-1.jpg": 989,
	"./resources/images/en/landing-vaccine-phone.png": 990,
	"./resources/images/en/landing.png": 991,
	"./resources/images/en/life-faq-banner-graphic.png": 992,
	"./resources/images/en/management_slider_phone1.png": 993,
	"./resources/images/en/management_slider_phone2.png": 994,
	"./resources/images/en/management_slider_phone3.png": 995,
	"./resources/images/en/management_slider_phone3副本.png": 996,
	"./resources/images/en/medical_cert_p1_1.png": 997,
	"./resources/images/en/medical_cert_p1_2.png": 998,
	"./resources/images/en/medical_cert_p2_1.png": 999,
	"./resources/images/en/medical_cert_p2_3.png": 1000,
	"./resources/images/en/medical_cert_p3_1.png": 1001,
	"./resources/images/en/medical_cert_slider_phone1.png": 1002,
	"./resources/images/en/medication_p1_2.png": 1003,
	"./resources/images/en/medication_p2_1.png": 1004,
	"./resources/images/en/medication_slider_phone1.png": 1005,
	"./resources/images/en/medication_slider_phone2.png": 1006,
	"./resources/images/en/medication_slider_phone3.png": 1007,
	"./resources/images/en/mobile-promotion_content.png": 1008,
	"./resources/images/en/mobile_child_usage0.png": 1009,
	"./resources/images/en/mobile_child_usage1.png": 1010,
	"./resources/images/en/mobile_download_phone.png": 1011,
	"./resources/images/en/my-family-campaign-banner-desktop.jpg": 1012,
	"./resources/images/en/my-family-campaign-banner-mobile.jpg": 1013,
	"./resources/images/en/my_family_doctor_p1_1.png": 1014,
	"./resources/images/en/my_family_doctor_slider_phone1.png": 1015,
	"./resources/images/en/new-item-tag.png": 1016,
	"./resources/images/en/news_p1_2.png": 1017,
	"./resources/images/en/news_p2_1.png": 1018,
	"./resources/images/en/news_p2_2.png": 1019,
	"./resources/images/en/news_slider_phone1.png": 1020,
	"./resources/images/en/news_slider_phone2.png": 1021,
	"./resources/images/en/on_one.png": 1022,
	"./resources/images/en/on_three.png": 1023,
	"./resources/images/en/on_two.png": 1024,
	"./resources/images/en/page-not-found.jpg": 1025,
	"./resources/images/en/personal_folder_p1_1.png": 1026,
	"./resources/images/en/personal_folder_p2_1.png": 1027,
	"./resources/images/en/personal_folder_slider_phone1.png": 1028,
	"./resources/images/en/personal_folder_tip_1.png": 1029,
	"./resources/images/en/personal_folder_tip_2.png": 1030,
	"./resources/images/en/privacy/keep-safe-tip05.png": 1031,
	"./resources/images/en/privacy/keep-safe-tip06.png": 1032,
	"./resources/images/en/program_slider_phone1.png": 1033,
	"./resources/images/en/program_slider_phone2.png": 1034,
	"./resources/images/en/program_slider_phone3.png": 1035,
	"./resources/images/en/promotion_content.png": 1036,
	"./resources/images/en/qr-baby.png": 1037,
	"./resources/images/en/qr_code_slider_phone1.png": 1038,
	"./resources/images/en/qr_code_slider_phone2.png": 1039,
	"./resources/images/en/qr_code_slider_phone3.png": 1040,
	"./resources/images/en/qr_code_slider_phone4.png": 1041,
	"./resources/images/en/qr_scanner_p1_1.png": 1042,
	"./resources/images/en/search_slider_phone1.png": 1043,
	"./resources/images/en/search_slider_phone2.png": 1044,
	"./resources/images/en/search_slider_phone3.png": 1045,
	"./resources/images/en/slider_phone1.png": 1046,
	"./resources/images/en/slider_phone2.png": 1047,
	"./resources/images/en/slider_phone3.png": 1048,
	"./resources/images/en/terms-banner-graphic.png": 1049,
	"./resources/images/en/truck-main-img.jpg": 1050,
	"./resources/images/en/truck-schedule-1.jpg": 1051,
	"./resources/images/en/truck-schedule-2.jpg": 1052,
	"./resources/images/en/under-16-input-info-2.png": 1053,
	"./resources/images/en/under16-gift-banner-desktop.jpg": 1054,
	"./resources/images/en/under16-gift-banner-mobile.jpg": 1055,
	"./resources/images/en/vaccine_p1_2.png": 1056,
	"./resources/images/en/vaccine_p2_1.png": 1057,
	"./resources/images/en/vaccine_p3_2.png": 1058,
	"./resources/images/en/vaccine_slider_phone1.png": 1059,
	"./resources/images/en/vaccine_slider_phone2.png": 1060,
	"./resources/images/en/vaccine_slider_phone3.png": 1061,
	"./resources/images/en/what-new-banner-desktop.jpg": 1062,
	"./resources/images/en/what-new-banner-mobile.jpg": 1063,
	"./resources/images/expand-button.png": 1064,
	"./resources/images/facebook-icon.png": 1065,
	"./resources/images/faq-banner-bg.jpg": 1066,
	"./resources/images/feature_6_icon.png": 1067,
	"./resources/images/feature_7_icon.png": 1068,
	"./resources/images/footer_facebookLogo.png": 1069,
	"./resources/images/footer_igLogo.png": 1070,
	"./resources/images/footer_youtubeLogo.png": 1071,
	"./resources/images/growth_icon.png": 1072,
	"./resources/images/growth_img.png": 1073,
	"./resources/images/health-management-bg.png": 1074,
	"./resources/images/health-management_p1_1.png": 1075,
	"./resources/images/health-management_p1_2.png": 1076,
	"./resources/images/health-management_p1_3.png": 1077,
	"./resources/images/health-management_p2_2.png": 1078,
	"./resources/images/health-management_p2_3.png": 1079,
	"./resources/images/health-management_p3_3.png": 1080,
	"./resources/images/health-management_p4_2.png": 1081,
	"./resources/images/health-news-bg.png": 1082,
	"./resources/images/health-program-bg.png": 1083,
	"./resources/images/health-program_cb_2.png": 1084,
	"./resources/images/health-program_p0_3.png": 1085,
	"./resources/images/health-program_p1_3.png": 1086,
	"./resources/images/health-program_p2_1.png": 1087,
	"./resources/images/health-program_p2_3.png": 1088,
	"./resources/images/health-program_p3_1.png": 1089,
	"./resources/images/health-program_p3_2.png": 1090,
	"./resources/images/health-program_p3_3.png": 1091,
	"./resources/images/health-program_p4_2.png": 1092,
	"./resources/images/health-program_p4_3.png": 1093,
	"./resources/images/healthcare_doc-bg.png": 1094,
	"./resources/images/healthcare_doc_p1_2.png": 1095,
	"./resources/images/home-play-button.png": 1096,
	"./resources/images/home_family_doctor_icon.png": 1097,
	"./resources/images/home_healthcare_document_icon.png": 1098,
	"./resources/images/home_investigation_icon.png": 1099,
	"./resources/images/home_medical_certificate_icon.png": 1100,
	"./resources/images/img_family.png": 1101,
	"./resources/images/instagram-icon.png": 1102,
	"./resources/images/investigation_add_img.png": 1103,
	"./resources/images/investigation_p1_2.png": 1104,
	"./resources/images/investigation_p2_2.png": 1105,
	"./resources/images/investigation_p2_3.png": 1106,
	"./resources/images/investigation_radi_2.png": 1107,
	"./resources/images/landing-health-management-icon.png": 1108,
	"./resources/images/landing-slider-img-1.jpg": 1109,
	"./resources/images/landing-vaccine-icon.png": 1110,
	"./resources/images/left_one.png": 1111,
	"./resources/images/left_three.png": 1112,
	"./resources/images/left_two.png": 1113,
	"./resources/images/life-faq-banner-bg.jpg": 1114,
	"./resources/images/life-overview-faq-btn.png": 1115,
	"./resources/images/life-overview-intro0.png": 1116,
	"./resources/images/life-overview-intro1.png": 1117,
	"./resources/images/life-overview-intro2.png": 1118,
	"./resources/images/life-overview-intro3.png": 1119,
	"./resources/images/life-overview-park-intro0.png": 1120,
	"./resources/images/life-overview-parklist-btn.png": 1121,
	"./resources/images/life-overview-point-btn.png": 1122,
	"./resources/images/life-overview-tutorial-btn.png": 1123,
	"./resources/images/life-school-thumbnail.png": 1124,
	"./resources/images/logo_color.png": 1125,
	"./resources/images/maintenance-icon.png": 1126,
	"./resources/images/medical_cert-bg.png": 1127,
	"./resources/images/medical_cert_p1_2.png": 1128,
	"./resources/images/medical_cert_p2_2.png": 1129,
	"./resources/images/medical_cert_p3_2.png": 1130,
	"./resources/images/medication_p1_1.png": 1131,
	"./resources/images/medication_p1_3.png": 1132,
	"./resources/images/medication_p2_2.png": 1133,
	"./resources/images/medication_p2_3.png": 1134,
	"./resources/images/my-family-add-16-above.png": 1135,
	"./resources/images/my-family-add-under16.png": 1136,
	"./resources/images/my-qr-add-member.png": 1137,
	"./resources/images/my-qr-attendance.png": 1138,
	"./resources/images/my-qr-registration.png": 1139,
	"./resources/images/my_family_doctor-bg.png": 1140,
	"./resources/images/my_family_doctor_p1_2.png": 1141,
	"./resources/images/news_icon.png": 1142,
	"./resources/images/news_img.png": 1143,
	"./resources/images/news_p1_1.png": 1144,
	"./resources/images/news_p1_3.png": 1145,
	"./resources/images/news_p2_3.png": 1146,
	"./resources/images/other-info-toggle.png": 1147,
	"./resources/images/overview-button-arrow.png": 1148,
	"./resources/images/pagination-next.png": 1149,
	"./resources/images/pagination-prev.png": 1150,
	"./resources/images/personal-folder-bg.png": 1151,
	"./resources/images/personal_folder_home_icon.png": 1152,
	"./resources/images/personal_folder_p1_2.png": 1153,
	"./resources/images/personal_folder_p2_2.png": 1154,
	"./resources/images/personal_folder_tip_3.png": 1155,
	"./resources/images/phone.png": 1156,
	"./resources/images/phone_bg.png": 1157,
	"./resources/images/ppp_icon.png": 1158,
	"./resources/images/ppp_img.png": 1159,
	"./resources/images/privacy-game/01_L.png": 280,
	"./resources/images/privacy-game/01_R.png": 281,
	"./resources/images/privacy-game/02_L.png": 282,
	"./resources/images/privacy-game/02_R.png": 283,
	"./resources/images/privacy-game/03_L.png": 284,
	"./resources/images/privacy-game/03_R.png": 285,
	"./resources/images/privacy-game/app-google.png": 1160,
	"./resources/images/privacy-game/app-huawei.png": 1161,
	"./resources/images/privacy-game/app-ios.png": 1162,
	"./resources/images/privacy-game/campaign-tite.png": 1163,
	"./resources/images/privacy-game/circle.png": 286,
	"./resources/images/privacy-game/game-result-en.png": 1164,
	"./resources/images/privacy-game/game-result-zh-CN.png": 1165,
	"./resources/images/privacy-game/game-result-zh-HK.png": 1166,
	"./resources/images/privacy-game/ico-arrow-down.png": 1167,
	"./resources/images/privacy-game/intro-desktop-en.png": 1168,
	"./resources/images/privacy-game/intro-desktop-zh-CN.png": 1169,
	"./resources/images/privacy-game/intro-desktop-zh-HK.png": 1170,
	"./resources/images/privacy-game/intro-mobile-en.png": 1171,
	"./resources/images/privacy-game/intro-mobile-zh-CN.png": 1172,
	"./resources/images/privacy-game/intro-mobile-zh-HK.png": 1173,
	"./resources/images/privacy-game/pic-instruction.png": 1174,
	"./resources/images/privacy-game/result-0-en.png": 1175,
	"./resources/images/privacy-game/result-0-zh-CN.png": 1176,
	"./resources/images/privacy-game/result-0-zh-HK.png": 1177,
	"./resources/images/privacy-game/result-0.png": 1178,
	"./resources/images/privacy-game/result-1-en.png": 1179,
	"./resources/images/privacy-game/result-1-zh-CN.png": 1180,
	"./resources/images/privacy-game/result-1-zh-HK.png": 1181,
	"./resources/images/privacy-game/result-1.png": 1182,
	"./resources/images/privacy-game/result-2-en.png": 1183,
	"./resources/images/privacy-game/result-2-zh-CN.png": 1184,
	"./resources/images/privacy-game/result-2-zh-HK.png": 1185,
	"./resources/images/privacy-game/result-2.png": 1186,
	"./resources/images/privacy-game/result-3-en.png": 1187,
	"./resources/images/privacy-game/result-3-zh-CN.png": 1188,
	"./resources/images/privacy-game/result-3-zh-HK.png": 1189,
	"./resources/images/privacy-game/result-3.png": 1190,
	"./resources/images/privacy-game/result-text-bg.png": 1191,
	"./resources/images/privacy-game/shrimp-grey.png": 1192,
	"./resources/images/privacy-game/shrimp-orange.png": 1193,
	"./resources/images/privacy-game/text-reduce-5.png": 287,
	"./resources/images/privacy-game/timer.png": 1194,
	"./resources/images/privacy-game/tips1-1-found.png": 1195,
	"./resources/images/privacy-game/tips1-1.png": 1196,
	"./resources/images/privacy-game/tips1-2-found.png": 1197,
	"./resources/images/privacy-game/tips1-2.png": 1198,
	"./resources/images/privacy-game/tips1-3-found.png": 1199,
	"./resources/images/privacy-game/tips1-3.png": 1200,
	"./resources/images/privacy-game/tips2-1-found.png": 1201,
	"./resources/images/privacy-game/tips2-1.png": 1202,
	"./resources/images/privacy-game/tips2-2-found.png": 1203,
	"./resources/images/privacy-game/tips2-2.png": 1204,
	"./resources/images/privacy-game/tips2-3-found.png": 1205,
	"./resources/images/privacy-game/tips2-3.png": 1206,
	"./resources/images/privacy-game/tips3-1-found.png": 1207,
	"./resources/images/privacy-game/tips3-1.png": 1208,
	"./resources/images/privacy-game/tips3-2-found.png": 1209,
	"./resources/images/privacy-game/tips3-2.png": 1210,
	"./resources/images/privacy-game/tips3-3-found.png": 1211,
	"./resources/images/privacy-game/tips3-3.png": 1212,
	"./resources/images/privacy/en/privacy-photo1-4.png": 1213,
	"./resources/images/privacy/keep-safe-tip01.png": 1214,
	"./resources/images/privacy/keep-safe-tip02.png": 1215,
	"./resources/images/privacy/keep-safe-tip03.png": 1216,
	"./resources/images/privacy/keep-safe-tip04.png": 1217,
	"./resources/images/privacy/keep-safe-tip05.png": 1218,
	"./resources/images/privacy/keep-safe-tip07.png": 1219,
	"./resources/images/privacy/keep-safe-tip08.png": 1220,
	"./resources/images/privacy/mobile-icon-1.png": 1221,
	"./resources/images/privacy/mobile-icon-2.png": 1222,
	"./resources/images/privacy/mobile-icon-3.png": 1223,
	"./resources/images/privacy/mobile-icon-4.png": 1224,
	"./resources/images/privacy/phishing-attack-tip01.png": 1225,
	"./resources/images/privacy/phishing-attack-tip02.png": 1226,
	"./resources/images/privacy/phishing-attack-tip03.png": 1227,
	"./resources/images/privacy/privacy-header-photo.png": 1228,
	"./resources/images/privacy/privacy-photo-empty.png": 1229,
	"./resources/images/privacy/privacy-photo1-1.png": 1230,
	"./resources/images/privacy/privacy-photo1-2-long.png": 1231,
	"./resources/images/privacy/privacy-photo1-2-mobile.png": 1232,
	"./resources/images/privacy/privacy-photo1-2.png": 1233,
	"./resources/images/privacy/privacy-photo1-3.png": 1234,
	"./resources/images/privacy/privacy-photo1-4.png": 1235,
	"./resources/images/privacy/privacy-photo2-3.png": 1236,
	"./resources/images/privacy/privacy-photo3-3.png": 1237,
	"./resources/images/privacy/privacy-reminder-1.png": 1238,
	"./resources/images/privacy/privacy-reminder-2.png": 1239,
	"./resources/images/privacy/privacy-reminder-3.png": 1240,
	"./resources/images/privacy/privacy-reminder-4.png": 1241,
	"./resources/images/privacy/zh-CN/privacy-photo1-4.png": 1242,
	"./resources/images/privacy/zh-HK/privacy-photo1-4.png": 1243,
	"./resources/images/pro-acc-mgmt-bg.png": 1244,
	"./resources/images/pro-info-sharing-bg.png": 1245,
	"./resources/images/pro-mini-assistant-bg.png": 1246,
	"./resources/images/pro-noti-center-bg.png": 1247,
	"./resources/images/promotion-flag-left.png": 1248,
	"./resources/images/promotion-flag-right.png": 1249,
	"./resources/images/promotion_bg.png": 1250,
	"./resources/images/promulgation/advertisement/ad-01.jpg": 1251,
	"./resources/images/promulgation/advertisement/ad-02.jpg": 1252,
	"./resources/images/promulgation/advertisement/ad-03.jpg": 1253,
	"./resources/images/promulgation/advertisement/ad-04.jpg": 1254,
	"./resources/images/promulgation/advertisement/ad-05.jpg": 1255,
	"./resources/images/promulgation/advertisement/ad-06.jpg": 1256,
	"./resources/images/promulgation/advertisement/ad-main-img.jpg": 1257,
	"./resources/images/promulgation/advertisement/bus-body-icon.png": 1258,
	"./resources/images/promulgation/advertisement/mini-bus-body-icon.png": 1259,
	"./resources/images/promulgation/advertisement/mtr-icon.png": 1260,
	"./resources/images/promulgation/advertisement/outdoor-tv-icon.png": 1261,
	"./resources/images/promulgation/advertisement/post-office.png": 1262,
	"./resources/images/promulgation/animation/animation-e1-icon.png": 1263,
	"./resources/images/promulgation/animation/animation-e2-icon.png": 1264,
	"./resources/images/promulgation/animation/animation-e3-icon.png": 1265,
	"./resources/images/promulgation/animation/en/animation-game-banner-mobile.jpg": 1266,
	"./resources/images/promulgation/animation/en/animation-game-banner.jpg": 1267,
	"./resources/images/promulgation/animation/en/promulgation-animation-main-img.jpg": 1268,
	"./resources/images/promulgation/animation/zh-CN/animation-game-banner-mobile.jpg": 1269,
	"./resources/images/promulgation/animation/zh-CN/animation-game-banner.jpg": 1270,
	"./resources/images/promulgation/animation/zh-CN/promulgation-animation-main-img.jpg": 1271,
	"./resources/images/promulgation/animation/zh-HK/animation-game-banner-mobile.jpg": 1272,
	"./resources/images/promulgation/animation/zh-HK/animation-game-banner.jpg": 1273,
	"./resources/images/promulgation/animation/zh-HK/promulgation-animation-main-img.jpg": 1274,
	"./resources/images/promulgation/interactive-pic-book/download-icon.png": 1275,
	"./resources/images/promulgation/interactive-pic-book/interactive-pic-book-01.jpg": 1276,
	"./resources/images/promulgation/interactive-pic-book/interactive-pic-book-preview-01.jpg": 1277,
	"./resources/images/promulgation/interactive-pic-book/interactive-pic-book-preview-02.jpg": 1278,
	"./resources/images/promulgation/interactive-pic-book/interactive-pic-book-preview-03.jpg": 1279,
	"./resources/images/promulgation/interactive-pic-book/pic-book-main-img.jpg": 1280,
	"./resources/images/promulgation/interactive-pic-book/pic-book-main-img2.jpg": 1281,
	"./resources/images/promulgation/interactive-pic-book/storytelling-01.jpg": 1282,
	"./resources/images/promulgation/interactive-pic-book/storytelling-02.jpg": 1283,
	"./resources/images/promulgation/interactive-pic-book/storytelling-03.jpg": 1284,
	"./resources/images/promulgation/landing/promulgation-landing-animation-icon.png": 1285,
	"./resources/images/promulgation/landing/promulgation-landing-animation.png": 1286,
	"./resources/images/promulgation/landing/promulgation-landing-download-icon.png": 1287,
	"./resources/images/promulgation/landing/promulgation-landing-download.png": 1288,
	"./resources/images/promulgation/landing/promulgation-landing-in-outdoor-ad-icon.png": 1289,
	"./resources/images/promulgation/landing/promulgation-landing-in-outdoor-ad.png": 1290,
	"./resources/images/promulgation/landing/promulgation-landing-picture-book-icon.png": 1291,
	"./resources/images/promulgation/landing/promulgation-landing-picture-book.png": 1292,
	"./resources/images/promulgation/landing/promulgation-landing-promo-truck-icon.png": 1293,
	"./resources/images/promulgation/landing/promulgation-landing-promo-truck.png": 1294,
	"./resources/images/promulgation/landing/promulgation-landing-promo-video-icon.png": 1295,
	"./resources/images/promulgation/landing/promulgation-landing-promo-video.png": 1296,
	"./resources/images/promulgation/landing/promulgation-landing-social-media-icon.png": 1297,
	"./resources/images/promulgation/landing/promulgation-landing-social-media.png": 1298,
	"./resources/images/promulgation/landing/promulgation-landing-souvenir-icon.png": 1299,
	"./resources/images/promulgation/landing/promulgation-landing-souvenir.png": 1300,
	"./resources/images/promulgation/landing/promulgation-landing-support-station-icon.png": 1301,
	"./resources/images/promulgation/landing/promulgation-landing-support-station.png": 1302,
	"./resources/images/promulgation/promotional-truck/truck-photo-01.jpg": 1303,
	"./resources/images/promulgation/promotional-truck/truck-photo-02.jpg": 1304,
	"./resources/images/promulgation/promotional-truck/truck-photo-03.jpg": 1305,
	"./resources/images/promulgation/promotional-truck/truck-photo-04.jpg": 1306,
	"./resources/images/promulgation/promotional-truck/truck-photo-05.jpg": 1307,
	"./resources/images/promulgation/promotional-truck/truck-photo-06.jpg": 1308,
	"./resources/images/promulgation/promotional-truck/truck-slider-1.jpg": 1309,
	"./resources/images/promulgation/promotional-truck/truck-slider-2.jpg": 1310,
	"./resources/images/promulgation/promotional-truck/truck-slider-3.jpg": 1311,
	"./resources/images/promulgation/support-station/en/support-station-main-img.jpg": 1312,
	"./resources/images/promulgation/support-station/support-station-photo-01.jpg": 1313,
	"./resources/images/promulgation/support-station/support-station-photo-02.jpg": 1314,
	"./resources/images/promulgation/support-station/support-station-photo-03.jpg": 1315,
	"./resources/images/promulgation/support-station/support-station-photo-04.jpg": 1316,
	"./resources/images/promulgation/support-station/zh-CN/support-station-main-img.jpg": 1317,
	"./resources/images/promulgation/support-station/zh-HK/support-station-main-img.jpg": 1318,
	"./resources/images/qr-scanner_function-1.png": 1319,
	"./resources/images/qr-scanner_function-2.png": 1320,
	"./resources/images/qr-scanner_function-3.png": 1321,
	"./resources/images/qr-scanner_p2_1.png": 1322,
	"./resources/images/qr-scanner_p2_2.png": 1323,
	"./resources/images/qr_scanner_p1_2.png": 1324,
	"./resources/images/qr_scanner_p1_3.png": 1325,
	"./resources/images/qr_top_bg.png": 1326,
	"./resources/images/qrcode-scanner-bg.png": 1327,
	"./resources/images/reminder-doctor-empty-bg.png": 1328,
	"./resources/images/reminder-doctor.png": 1329,
	"./resources/images/reminder_tick_box.png": 1330,
	"./resources/images/result-doctor-search-icon.png": 1331,
	"./resources/images/right_five.png": 1332,
	"./resources/images/right_one.png": 1333,
	"./resources/images/right_six.png": 1334,
	"./resources/images/right_three.png": 1335,
	"./resources/images/right_two.png": 1336,
	"./resources/images/scan-qr-add-member.png": 1337,
	"./resources/images/scan-qr-consent.png": 1338,
	"./resources/images/scan-qr-licence-scanner.png": 1339,
	"./resources/images/scan-qr-med-cert.png": 1340,
	"./resources/images/slider-left.png": 1341,
	"./resources/images/slider-right.png": 1342,
	"./resources/images/terms-banner-bg.jpg": 1343,
	"./resources/images/title-baby-deco.png": 1344,
	"./resources/images/title-child-deco.png": 1345,
	"./resources/images/tooltip-icon.png": 1346,
	"./resources/images/under16-birth-kit-graphic.png": 1347,
	"./resources/images/under16-birth-kit-icon.png": 1348,
	"./resources/images/under16-earn-coin-icon.png": 1349,
	"./resources/images/under16-mission-redemption-btn.png": 1350,
	"./resources/images/under16-mission1-graphic.png": 1351,
	"./resources/images/under16-mission2-graphic.png": 1352,
	"./resources/images/under16-under1-pack-btn.png": 1353,
	"./resources/images/under16-under16-pack-btn.png": 1354,
	"./resources/images/vaccine_p1_1.png": 1355,
	"./resources/images/vaccine_p1_2.png": 1356,
	"./resources/images/vaccine_p1_3.png": 1357,
	"./resources/images/vaccine_p2_2.png": 1358,
	"./resources/images/vaccine_p2_3.png": 1359,
	"./resources/images/vaccine_p3_1.png": 1360,
	"./resources/images/vaccine_p3_3.png": 1361,
	"./resources/images/vaccine_slider_phone1.png": 1362,
	"./resources/images/vaccine_slider_phone2.png": 1363,
	"./resources/images/vaccine_slider_phone3.png": 1364,
	"./resources/images/w3c_logo.png": 1365,
	"./resources/images/whats-new/elife-general-go-to-park.png": 1366,
	"./resources/images/whats-new/elife-redemption-event.png": 1367,
	"./resources/images/whats-new/en/elife-news-50x-coins.png": 1368,
	"./resources/images/whats-new/en/news-lab-report-jan24.png": 1369,
	"./resources/images/whats-new/news-cm-allergy.png": 1370,
	"./resources/images/whats-new/news-lab-report-jan24.png": 1371,
	"./resources/images/whats-new/news-med-cert-scanner.png": 1372,
	"./resources/images/whats-new/news-newborn-pack.png": 1373,
	"./resources/images/whats-new/news-pro-assistant.png": 1374,
	"./resources/images/whats-new/news-pro-broadcast.png": 1375,
	"./resources/images/whats-new/news-pro-enrolled-program.png": 1376,
	"./resources/images/whats-new/news-qrcode-registration.png": 1377,
	"./resources/images/whats-new/news-radi-report.png": 1378,
	"./resources/images/whats-new/news-under16-health-coins.png": 1379,
	"./resources/images/whats-new/news-under16-registration.png": 1380,
	"./resources/images/whats-new/zh-CN/elife-news-50x-coins.png": 1381,
	"./resources/images/whats-new/zh-CN/news-lab-report-jan24.png": 1382,
	"./resources/images/whats-new/zh-HK/elife-news-50x-coins.png": 1383,
	"./resources/images/whats-new/zh-HK/news-lab-report-jan24.png": 1384,
	"./resources/images/xxhdpi/Group_4.png": 1385,
	"./resources/images/zh-CN/01_news.png": 1386,
	"./resources/images/zh-CN/02_doctor.png": 1387,
	"./resources/images/zh-CN/03_growth.png": 1388,
	"./resources/images/zh-CN/04_appointment.png": 1389,
	"./resources/images/zh-CN/05_allergy.png": 1390,
	"./resources/images/zh-CN/06_voucher.png": 1391,
	"./resources/images/zh-CN/07_caregiver.png": 1392,
	"./resources/images/zh-CN/08_family.png": 1393,
	"./resources/images/zh-CN/16-above-input-info-1.png": 1394,
	"./resources/images/zh-CN/16-above-input-info-2.png": 1395,
	"./resources/images/zh-CN/16-above-scan-1.png": 1396,
	"./resources/images/zh-CN/16-above-scan-2.png": 1397,
	"./resources/images/zh-CN/Frame_1.png": 1398,
	"./resources/images/zh-CN/QR-baby-mobile.png": 1399,
	"./resources/images/zh-CN/allergy_p1_2.png": 1400,
	"./resources/images/zh-CN/allergy_p2_1.png": 1401,
	"./resources/images/zh-CN/allergy_slider_phone1.png": 1402,
	"./resources/images/zh-CN/allergy_slider_phone2.png": 1403,
	"./resources/images/zh-CN/allergy_slider_phone3.png": 1404,
	"./resources/images/zh-CN/apk-dl-btn.png": 1405,
	"./resources/images/zh-CN/app_store.png": 1406,
	"./resources/images/zh-CN/appointment_p1_1.png": 1407,
	"./resources/images/zh-CN/appointment_p2_1.png": 1408,
	"./resources/images/zh-CN/appointment_p3_2.png": 1409,
	"./resources/images/zh-CN/appointment_p4_1.png": 1410,
	"./resources/images/zh-CN/appointment_slider_phone1.png": 1411,
	"./resources/images/zh-CN/appointment_slider_phone2.png": 1412,
	"./resources/images/zh-CN/appointment_slider_phone3.png": 1413,
	"./resources/images/zh-CN/banner_record.png": 1414,
	"./resources/images/zh-CN/banner_record_bg.png": 1415,
	"./resources/images/zh-CN/birth-cert-step1.png": 1416,
	"./resources/images/zh-CN/birth-cert-step2.png": 1417,
	"./resources/images/zh-CN/birth-cert-step3.png": 1418,
	"./resources/images/zh-CN/birth-cert-step4.png": 1419,
	"./resources/images/zh-CN/bk-download_phone.png": 1420,
	"./resources/images/zh-CN/calculator-result-under-age-12.png": 1421,
	"./resources/images/zh-CN/calculator-result-under-age-5.jpg": 1422,
	"./resources/images/zh-CN/caregiver_p1_1.png": 1423,
	"./resources/images/zh-CN/caregiver_p2_1.png": 1424,
	"./resources/images/zh-CN/caregiver_p3_1.png": 1425,
	"./resources/images/zh-CN/caregiver_slider_phone1.png": 1426,
	"./resources/images/zh-CN/caregiver_slider_phone2.png": 1427,
	"./resources/images/zh-CN/caregiver_slider_phone3.png": 1428,
	"./resources/images/zh-CN/caregiver_tip_1.png": 1429,
	"./resources/images/zh-CN/cbhr_slider_phone1.png": 1430,
	"./resources/images/zh-CN/child_p1.png": 1431,
	"./resources/images/zh-CN/child_p1_1.png": 1432,
	"./resources/images/zh-CN/child_p2.png": 1433,
	"./resources/images/zh-CN/child_p3.png": 1434,
	"./resources/images/zh-CN/child_usage0.png": 1435,
	"./resources/images/zh-CN/child_usage1.png": 1436,
	"./resources/images/zh-CN/child_usage2.png": 1437,
	"./resources/images/zh-CN/covid19-adolescent-top-banner.png": 1438,
	"./resources/images/zh-CN/covid_adolescent_p1_1.png": 1439,
	"./resources/images/zh-CN/covid_adolescent_p2_1.png": 1440,
	"./resources/images/zh-CN/covid_adolescent_p4_1.png": 1441,
	"./resources/images/zh-CN/covid_adolescent_p4_2.png": 1442,
	"./resources/images/zh-CN/covid_adolescent_p5_1.png": 1443,
	"./resources/images/zh-CN/covid_qr_export_1.png": 1444,
	"./resources/images/zh-CN/covid_qr_export_2.png": 1445,
	"./resources/images/zh-CN/covid_qr_export_3.png": 1446,
	"./resources/images/zh-CN/covid_qr_indicate_1-1.gif": 1447,
	"./resources/images/zh-CN/covid_qr_indicate_2-1.gif": 1448,
	"./resources/images/zh-CN/covid_qr_p0.png": 1449,
	"./resources/images/zh-CN/covid_qr_p1_1.png": 1450,
	"./resources/images/zh-CN/covid_qr_p1_1_mobile.png": 1451,
	"./resources/images/zh-CN/covid_qr_p1_2.png": 1452,
	"./resources/images/zh-CN/covid_qr_p1_2_mobile.png": 1453,
	"./resources/images/zh-CN/covid_qr_p1_3.png": 1454,
	"./resources/images/zh-CN/covid_qr_p2_1.gif": 1455,
	"./resources/images/zh-CN/covid_qr_p2_1.png": 1456,
	"./resources/images/zh-CN/covid_qr_p2_1_mobile.gif": 1457,
	"./resources/images/zh-CN/covid_qr_p2_1_mobile.png": 1458,
	"./resources/images/zh-CN/covid_qr_p2_2.png": 1459,
	"./resources/images/zh-CN/covid_qr_p2_2_mobile.png": 1460,
	"./resources/images/zh-CN/covid_qr_p2_3.png": 1461,
	"./resources/images/zh-CN/covid_qr_p3_1.png": 1462,
	"./resources/images/zh-CN/covid_qr_p3_1_mobile.png": 1463,
	"./resources/images/zh-CN/covid_qr_p4_1.png": 1464,
	"./resources/images/zh-CN/covid_qr_p4_2.png": 1465,
	"./resources/images/zh-CN/desktop.ini": 1466,
	"./resources/images/zh-CN/doctor-search_p1_1.png": 1467,
	"./resources/images/zh-CN/doctor-search_p1_3.png": 1468,
	"./resources/images/zh-CN/doctor-search_p2_1.png": 1469,
	"./resources/images/zh-CN/doctor-search_p2_2.png": 1470,
	"./resources/images/zh-CN/doctor-search_p3_1.png": 1471,
	"./resources/images/zh-CN/doctor-search_p4_2.png": 1472,
	"./resources/images/zh-CN/download-apk-phone.png": 1473,
	"./resources/images/zh-CN/download-bg-banner-graphic.png": 1474,
	"./resources/images/zh-CN/download-sticker-banner-graphic.png": 1475,
	"./resources/images/zh-CN/download_phone.png": 1476,
	"./resources/images/zh-CN/ehealth_50x_coins_banner_desktop.jpg": 1477,
	"./resources/images/zh-CN/ehealth_50x_coins_banner_mobile.jpg": 1478,
	"./resources/images/zh-CN/ehealth_adolescent_banner_desktop.png": 1479,
	"./resources/images/zh-CN/ehealth_adolescent_banner_mobile.png": 1480,
	"./resources/images/zh-CN/ehealth_bpbg_banner_desktop.jpg": 1481,
	"./resources/images/zh-CN/ehealth_bpbg_banner_mobile.jpg": 1482,
	"./resources/images/zh-CN/ehealth_calculator_banner_desktop.jpg": 1483,
	"./resources/images/zh-CN/ehealth_calculator_banner_desktop.png": 1484,
	"./resources/images/zh-CN/ehealth_calculator_banner_mobile.jpg": 1485,
	"./resources/images/zh-CN/ehealth_calculator_banner_mobile.png": 1486,
	"./resources/images/zh-CN/ehealth_cbhr_banner_desktop.jpg": 1487,
	"./resources/images/zh-CN/ehealth_cbhr_banner_mobile.jpg": 1488,
	"./resources/images/zh-CN/ehealth_dental_banner_desktop.jpg": 1489,
	"./resources/images/zh-CN/ehealth_dental_banner_mobile.jpg": 1490,
	"./resources/images/zh-CN/ehealth_ehr_lite_banner_desktop.jpg": 1491,
	"./resources/images/zh-CN/ehealth_ehr_lite_banner_mobile.jpg": 1492,
	"./resources/images/zh-CN/ehealth_health_coins_redemption_banner_desktop.jpg": 1493,
	"./resources/images/zh-CN/ehealth_health_coins_redemption_banner_mobile.jpg": 1494,
	"./resources/images/zh-CN/ehealth_lab_record_banner_desktop.jpg": 1495,
	"./resources/images/zh-CN/ehealth_lab_record_banner_mobile.jpg": 1496,
	"./resources/images/zh-CN/ehealth_latest_news_banner_desktop.jpg": 1497,
	"./resources/images/zh-CN/ehealth_latest_news_banner_mobile.jpg": 1498,
	"./resources/images/zh-CN/ehealth_minor_redemption_banner_desktop.jpg": 1499,
	"./resources/images/zh-CN/ehealth_minor_redemption_banner_mobile.jpg": 1500,
	"./resources/images/zh-CN/ehealth_minor_reg_banner_desktop.jpg": 1501,
	"./resources/images/zh-CN/ehealth_minor_reg_banner_mobile.jpg": 1502,
	"./resources/images/zh-CN/ehealth_personal_folder_banner_desktop.jpg": 1503,
	"./resources/images/zh-CN/ehealth_personal_folder_banner_mobile.jpg": 1504,
	"./resources/images/zh-CN/ehealth_radi_record_banner_desktop.jpg": 1505,
	"./resources/images/zh-CN/ehealth_radi_record_banner_mobile.jpg": 1506,
	"./resources/images/zh-CN/ehealth_survey_banner_desktop.png": 1507,
	"./resources/images/zh-CN/ehealth_survey_banner_mobile.png": 1508,
	"./resources/images/zh-CN/ehealth_website_banner_desktop.jpg": 1509,
	"./resources/images/zh-CN/ehealth_website_banner_mobile.jpg": 1510,
	"./resources/images/zh-CN/ehealthpro_acc_mgmt_slider_phone1.png": 1511,
	"./resources/images/zh-CN/ehealthpro_faq-banner-graphic.png": 1512,
	"./resources/images/zh-CN/ehealthpro_info_share_slider_phone1.png": 1513,
	"./resources/images/zh-CN/ehealthpro_mini_assistant_slider_phone1.png": 1514,
	"./resources/images/zh-CN/ehealthpro_noti_center_slider_phone1.png": 1515,
	"./resources/images/zh-CN/ehealthpro_noti_center_slider_phone2.png": 1516,
	"./resources/images/zh-CN/ehealthpro_slider_phone1.png": 1517,
	"./resources/images/zh-CN/faq-banner-graphic.png": 1518,
	"./resources/images/zh-CN/google_play.png": 1519,
	"./resources/images/zh-CN/health-management_p1_1.png": 1520,
	"./resources/images/zh-CN/health-management_p2_1.png": 1521,
	"./resources/images/zh-CN/health-management_p3_1.png": 1522,
	"./resources/images/zh-CN/health-management_p3_2.png": 1523,
	"./resources/images/zh-CN/health-management_p4_1.png": 1524,
	"./resources/images/zh-CN/health-program_cb_1.png": 1525,
	"./resources/images/zh-CN/health-program_p0_1.png": 1526,
	"./resources/images/zh-CN/health-program_p0_2.png": 1527,
	"./resources/images/zh-CN/health-program_p1_1.png": 1528,
	"./resources/images/zh-CN/health-program_p1_2.png": 1529,
	"./resources/images/zh-CN/health-program_p2_2.png": 1530,
	"./resources/images/zh-CN/health-program_p3_1.png": 1531,
	"./resources/images/zh-CN/health-program_p4_1.png": 1532,
	"./resources/images/zh-CN/health-program_p4_3.png": 1533,
	"./resources/images/zh-CN/healthcare_doc_p1_1.png": 1534,
	"./resources/images/zh-CN/healthcare_doc_slider_phone1.png": 1535,
	"./resources/images/zh-CN/healthcare_doc_slider_phone2.png": 1536,
	"./resources/images/zh-CN/healthcare_doc_slider_phone3.png": 1537,
	"./resources/images/zh-CN/home_allergy.png": 1538,
	"./resources/images/zh-CN/home_appointments.png": 1539,
	"./resources/images/zh-CN/home_caregiver.png": 1540,
	"./resources/images/zh-CN/home_cbhr.png": 1541,
	"./resources/images/zh-CN/home_family_doctor.png": 1542,
	"./resources/images/zh-CN/home_health_news.png": 1543,
	"./resources/images/zh-CN/home_health_programme.png": 1544,
	"./resources/images/zh-CN/home_healthcare_document.png": 1545,
	"./resources/images/zh-CN/home_investigation.png": 1546,
	"./resources/images/zh-CN/home_investigations.png": 1547,
	"./resources/images/zh-CN/home_medical_certificate.png": 1548,
	"./resources/images/zh-CN/home_medical_certificate_icon.png": 1549,
	"./resources/images/zh-CN/home_medication.png": 1550,
	"./resources/images/zh-CN/home_personal_folder.png": 1551,
	"./resources/images/zh-CN/home_vaccine.png": 1552,
	"./resources/images/zh-CN/huawei.png": 1553,
	"./resources/images/zh-CN/img_growth.png": 1554,
	"./resources/images/zh-CN/investigation_p1_1.png": 1555,
	"./resources/images/zh-CN/investigation_p2_1.png": 1556,
	"./resources/images/zh-CN/investigation_radi_1.png": 1557,
	"./resources/images/zh-CN/investigation_slider_phone1.png": 1558,
	"./resources/images/zh-CN/investigation_slider_phone2.png": 1559,
	"./resources/images/zh-CN/investigation_slider_phone3.png": 1560,
	"./resources/images/zh-CN/land-elife-banner-img-mobile.jpg": 1561,
	"./resources/images/zh-CN/land-elife-banner-img.jpg": 1562,
	"./resources/images/zh-CN/land-scanner-banner-img-mobile.jpg": 1563,
	"./resources/images/zh-CN/land-scanner-banner-img.jpg": 1564,
	"./resources/images/zh-CN/landing-health-management-phone.png": 1565,
	"./resources/images/zh-CN/landing-slider-img-1-mobile.jpg": 1566,
	"./resources/images/zh-CN/landing-slider-img-1.jpg": 1567,
	"./resources/images/zh-CN/landing-vaccine-phone.png": 1568,
	"./resources/images/zh-CN/landing.png": 1569,
	"./resources/images/zh-CN/life-faq-banner-graphic.png": 1570,
	"./resources/images/zh-CN/management_slider_phone1.png": 1571,
	"./resources/images/zh-CN/management_slider_phone2.png": 1572,
	"./resources/images/zh-CN/management_slider_phone3.png": 1573,
	"./resources/images/zh-CN/medical_cert_p1_1.png": 1574,
	"./resources/images/zh-CN/medical_cert_p1_2.png": 1575,
	"./resources/images/zh-CN/medical_cert_p2_1.png": 1576,
	"./resources/images/zh-CN/medical_cert_p2_3.png": 1577,
	"./resources/images/zh-CN/medical_cert_p3_1.png": 1578,
	"./resources/images/zh-CN/medical_cert_slider_phone1.png": 1579,
	"./resources/images/zh-CN/medication_p1_2.png": 1580,
	"./resources/images/zh-CN/medication_p2_1.png": 1581,
	"./resources/images/zh-CN/medication_slider_phone1.png": 1582,
	"./resources/images/zh-CN/medication_slider_phone2.png": 1583,
	"./resources/images/zh-CN/medication_slider_phone3.png": 1584,
	"./resources/images/zh-CN/mobile-promotion_content.png": 1585,
	"./resources/images/zh-CN/mobile_child_usage0.png": 1586,
	"./resources/images/zh-CN/mobile_child_usage1.png": 1587,
	"./resources/images/zh-CN/mobile_download_phone.png": 1588,
	"./resources/images/zh-CN/my-family-campaign-banner-desktop.jpg": 1589,
	"./resources/images/zh-CN/my-family-campaign-banner-mobile.jpg": 1590,
	"./resources/images/zh-CN/my_family_doctor_p1_1.png": 1591,
	"./resources/images/zh-CN/my_family_doctor_slider_phone1.png": 1592,
	"./resources/images/zh-CN/new-item-tag.png": 1593,
	"./resources/images/zh-CN/news_p1_2.png": 1594,
	"./resources/images/zh-CN/news_p2_1.png": 1595,
	"./resources/images/zh-CN/news_p2_2.png": 1596,
	"./resources/images/zh-CN/news_slider_phone1.png": 1597,
	"./resources/images/zh-CN/news_slider_phone2.png": 1598,
	"./resources/images/zh-CN/on_one.png": 1599,
	"./resources/images/zh-CN/on_three.png": 1600,
	"./resources/images/zh-CN/on_two.png": 1601,
	"./resources/images/zh-CN/page-not-found.jpg": 1602,
	"./resources/images/zh-CN/personal_folder_p1_1.png": 1603,
	"./resources/images/zh-CN/personal_folder_p2_1.png": 1604,
	"./resources/images/zh-CN/personal_folder_slider_phone1.png": 1605,
	"./resources/images/zh-CN/personal_folder_tip_1.png": 1606,
	"./resources/images/zh-CN/personal_folder_tip_2.png": 1607,
	"./resources/images/zh-CN/privacy/keep-safe-tip05.png": 1608,
	"./resources/images/zh-CN/privacy/keep-safe-tip06.png": 1609,
	"./resources/images/zh-CN/program_slider_phone1.png": 1610,
	"./resources/images/zh-CN/program_slider_phone2.png": 1611,
	"./resources/images/zh-CN/program_slider_phone3.png": 1612,
	"./resources/images/zh-CN/promotion_content.png": 1613,
	"./resources/images/zh-CN/qr-baby.png": 1614,
	"./resources/images/zh-CN/qr_code_slider_phone1.png": 1615,
	"./resources/images/zh-CN/qr_code_slider_phone2.png": 1616,
	"./resources/images/zh-CN/qr_code_slider_phone3.png": 1617,
	"./resources/images/zh-CN/qr_code_slider_phone4.png": 1618,
	"./resources/images/zh-CN/qr_scanner_p1_1.png": 1619,
	"./resources/images/zh-CN/search_slider_phone1.png": 1620,
	"./resources/images/zh-CN/search_slider_phone2.png": 1621,
	"./resources/images/zh-CN/search_slider_phone3.png": 1622,
	"./resources/images/zh-CN/slider_phone1.png": 1623,
	"./resources/images/zh-CN/slider_phone2.png": 1624,
	"./resources/images/zh-CN/slider_phone3.png": 1625,
	"./resources/images/zh-CN/terms-banner-graphic.png": 1626,
	"./resources/images/zh-CN/test-1400px.png": 1627,
	"./resources/images/zh-CN/truck-main-img.jpg": 1628,
	"./resources/images/zh-CN/truck-schedule-1.jpg": 1629,
	"./resources/images/zh-CN/truck-schedule-2.jpg": 1630,
	"./resources/images/zh-CN/under-16-input-info-2.png": 1631,
	"./resources/images/zh-CN/under16-gift-banner-desktop.jpg": 1632,
	"./resources/images/zh-CN/under16-gift-banner-mobile.jpg": 1633,
	"./resources/images/zh-CN/vaccine_p1_2.png": 1634,
	"./resources/images/zh-CN/vaccine_p2_1.png": 1635,
	"./resources/images/zh-CN/vaccine_p3_2.png": 1636,
	"./resources/images/zh-CN/vaccine_slider_phone1.png": 1637,
	"./resources/images/zh-CN/vaccine_slider_phone2.png": 1638,
	"./resources/images/zh-CN/vaccine_slider_phone3.png": 1639,
	"./resources/images/zh-CN/what-new-banner-desktop.jpg": 1640,
	"./resources/images/zh-CN/what-new-banner-mobile.jpg": 1641,
	"./resources/images/zh-CN/what-new-banner.jpg": 1642,
	"./resources/images/zh-HK/01_news.png": 1643,
	"./resources/images/zh-HK/02_doctor.png": 1644,
	"./resources/images/zh-HK/03_growth.png": 1645,
	"./resources/images/zh-HK/04_appointment.png": 1646,
	"./resources/images/zh-HK/05_allergy.png": 1647,
	"./resources/images/zh-HK/06_voucher.png": 1648,
	"./resources/images/zh-HK/07_caregiver.png": 1649,
	"./resources/images/zh-HK/08_family.png": 1650,
	"./resources/images/zh-HK/16-above-input-info-1.png": 1651,
	"./resources/images/zh-HK/16-above-input-info-2.png": 1652,
	"./resources/images/zh-HK/16-above-scan-1.png": 1653,
	"./resources/images/zh-HK/16-above-scan-2.png": 1654,
	"./resources/images/zh-HK/Frame_1.png": 1655,
	"./resources/images/zh-HK/QR-baby-mobile.png": 1656,
	"./resources/images/zh-HK/allergy_p1_2.png": 1657,
	"./resources/images/zh-HK/allergy_p2_1.png": 1658,
	"./resources/images/zh-HK/allergy_p2_2.png": 1659,
	"./resources/images/zh-HK/allergy_slider_phone1.png": 1660,
	"./resources/images/zh-HK/allergy_slider_phone2.png": 1661,
	"./resources/images/zh-HK/allergy_slider_phone3.png": 1662,
	"./resources/images/zh-HK/apk-dl-btn.png": 1663,
	"./resources/images/zh-HK/app_store.png": 1664,
	"./resources/images/zh-HK/appointment_p1_1.png": 1665,
	"./resources/images/zh-HK/appointment_p2_1.png": 1666,
	"./resources/images/zh-HK/appointment_p3_2.png": 1667,
	"./resources/images/zh-HK/appointment_p4_1.png": 1668,
	"./resources/images/zh-HK/appointment_slider_phone1.png": 1669,
	"./resources/images/zh-HK/appointment_slider_phone2.png": 1670,
	"./resources/images/zh-HK/appointment_slider_phone3.png": 1671,
	"./resources/images/zh-HK/banner_record.png": 1672,
	"./resources/images/zh-HK/banner_record_bg.png": 1673,
	"./resources/images/zh-HK/birth-cert-step1.png": 1674,
	"./resources/images/zh-HK/birth-cert-step2.png": 1675,
	"./resources/images/zh-HK/birth-cert-step3.png": 1676,
	"./resources/images/zh-HK/birth-cert-step4.png": 1677,
	"./resources/images/zh-HK/bk-download_phone.png": 1678,
	"./resources/images/zh-HK/calculator-result-under-age-12.png": 1679,
	"./resources/images/zh-HK/calculator-result-under-age-5.jpg": 1680,
	"./resources/images/zh-HK/caregiver_p1_1.png": 1681,
	"./resources/images/zh-HK/caregiver_p2_1.png": 1682,
	"./resources/images/zh-HK/caregiver_p3_1.png": 1683,
	"./resources/images/zh-HK/caregiver_slider_phone1.png": 1684,
	"./resources/images/zh-HK/caregiver_slider_phone2.png": 1685,
	"./resources/images/zh-HK/caregiver_slider_phone3.png": 1686,
	"./resources/images/zh-HK/caregiver_tip_1.png": 1687,
	"./resources/images/zh-HK/cbhr_slider_phone1.png": 1688,
	"./resources/images/zh-HK/child_p1.png": 1689,
	"./resources/images/zh-HK/child_p1_1.png": 1690,
	"./resources/images/zh-HK/child_p2.png": 1691,
	"./resources/images/zh-HK/child_p3.png": 1692,
	"./resources/images/zh-HK/child_usage0.png": 1693,
	"./resources/images/zh-HK/child_usage1.png": 1694,
	"./resources/images/zh-HK/child_usage2.png": 1695,
	"./resources/images/zh-HK/covid19-adolescent-top-banner.png": 1696,
	"./resources/images/zh-HK/covid_adolescent_p1_1.png": 1697,
	"./resources/images/zh-HK/covid_adolescent_p2_1.png": 1698,
	"./resources/images/zh-HK/covid_adolescent_p4_1.png": 1699,
	"./resources/images/zh-HK/covid_adolescent_p4_2.png": 1700,
	"./resources/images/zh-HK/covid_adolescent_p5_1.png": 1701,
	"./resources/images/zh-HK/covid_qr_export_1.png": 1702,
	"./resources/images/zh-HK/covid_qr_export_2.png": 1703,
	"./resources/images/zh-HK/covid_qr_export_3.png": 1704,
	"./resources/images/zh-HK/covid_qr_indicate_1-1.gif": 1705,
	"./resources/images/zh-HK/covid_qr_indicate_2-1.gif": 1706,
	"./resources/images/zh-HK/covid_qr_p0.png": 1707,
	"./resources/images/zh-HK/covid_qr_p1_1.png": 1708,
	"./resources/images/zh-HK/covid_qr_p1_1_mobile.png": 1709,
	"./resources/images/zh-HK/covid_qr_p1_2.png": 1710,
	"./resources/images/zh-HK/covid_qr_p1_2_mobile.png": 1711,
	"./resources/images/zh-HK/covid_qr_p1_3.png": 1712,
	"./resources/images/zh-HK/covid_qr_p2_1.gif": 1713,
	"./resources/images/zh-HK/covid_qr_p2_1.png": 1714,
	"./resources/images/zh-HK/covid_qr_p2_1_mobile.gif": 1715,
	"./resources/images/zh-HK/covid_qr_p2_1_mobile.png": 1716,
	"./resources/images/zh-HK/covid_qr_p2_2.png": 1717,
	"./resources/images/zh-HK/covid_qr_p2_2_mobile.png": 1718,
	"./resources/images/zh-HK/covid_qr_p2_3.png": 1719,
	"./resources/images/zh-HK/covid_qr_p3_1.png": 1720,
	"./resources/images/zh-HK/covid_qr_p3_1_mobile.png": 1721,
	"./resources/images/zh-HK/covid_qr_p4_1.png": 1722,
	"./resources/images/zh-HK/covid_qr_p4_2.png": 1723,
	"./resources/images/zh-HK/desktop.ini": 1724,
	"./resources/images/zh-HK/doctor-search_p1_1.png": 1725,
	"./resources/images/zh-HK/doctor-search_p1_3.png": 1726,
	"./resources/images/zh-HK/doctor-search_p2_1.png": 1727,
	"./resources/images/zh-HK/doctor-search_p2_2.png": 1728,
	"./resources/images/zh-HK/doctor-search_p3_1.png": 1729,
	"./resources/images/zh-HK/doctor-search_p4_2.png": 1730,
	"./resources/images/zh-HK/download-apk-phone.png": 1731,
	"./resources/images/zh-HK/download-bg-banner-graphic.png": 1732,
	"./resources/images/zh-HK/download-sticker-banner-graphic.png": 1733,
	"./resources/images/zh-HK/download_phone.png": 1734,
	"./resources/images/zh-HK/ehealth_50x_coins_banner_desktop.jpg": 1735,
	"./resources/images/zh-HK/ehealth_50x_coins_banner_mobile.jpg": 1736,
	"./resources/images/zh-HK/ehealth_adolescent_banner_desktop.png": 1737,
	"./resources/images/zh-HK/ehealth_adolescent_banner_mobile.png": 1738,
	"./resources/images/zh-HK/ehealth_bpbg_banner_desktop.jpg": 1739,
	"./resources/images/zh-HK/ehealth_bpbg_banner_mobile.jpg": 1740,
	"./resources/images/zh-HK/ehealth_calculator_banner_desktop.jpg": 1741,
	"./resources/images/zh-HK/ehealth_calculator_banner_desktop.png": 1742,
	"./resources/images/zh-HK/ehealth_calculator_banner_mobile.jpg": 1743,
	"./resources/images/zh-HK/ehealth_calculator_banner_mobile.png": 1744,
	"./resources/images/zh-HK/ehealth_cbhr_banner_desktop.jpg": 1745,
	"./resources/images/zh-HK/ehealth_cbhr_banner_mobile.jpg": 1746,
	"./resources/images/zh-HK/ehealth_dental_banner_desktop.jpg": 1747,
	"./resources/images/zh-HK/ehealth_dental_banner_mobile.jpg": 1748,
	"./resources/images/zh-HK/ehealth_ehr_lite_banner_desktop.jpg": 1749,
	"./resources/images/zh-HK/ehealth_ehr_lite_banner_mobile.jpg": 1750,
	"./resources/images/zh-HK/ehealth_health_coins_redemption_banner_desktop.jpg": 1751,
	"./resources/images/zh-HK/ehealth_health_coins_redemption_banner_mobile.jpg": 1752,
	"./resources/images/zh-HK/ehealth_lab_record_banner_desktop.jpg": 1753,
	"./resources/images/zh-HK/ehealth_lab_record_banner_mobile.jpg": 1754,
	"./resources/images/zh-HK/ehealth_latest_news_banner_desktop.jpg": 1755,
	"./resources/images/zh-HK/ehealth_latest_news_banner_mobile.jpg": 1756,
	"./resources/images/zh-HK/ehealth_minor_redemption_banner_desktop.jpg": 1757,
	"./resources/images/zh-HK/ehealth_minor_redemption_banner_mobile.jpg": 1758,
	"./resources/images/zh-HK/ehealth_minor_reg_banner_desktop.jpg": 1759,
	"./resources/images/zh-HK/ehealth_minor_reg_banner_mobile.jpg": 1760,
	"./resources/images/zh-HK/ehealth_personal_folder_banner_desktop.jpg": 1761,
	"./resources/images/zh-HK/ehealth_personal_folder_banner_mobile.jpg": 1762,
	"./resources/images/zh-HK/ehealth_radi_record_banner_desktop.jpg": 1763,
	"./resources/images/zh-HK/ehealth_radi_record_banner_mobile.jpg": 1764,
	"./resources/images/zh-HK/ehealth_survey_banner_desktop.png": 1765,
	"./resources/images/zh-HK/ehealth_survey_banner_mobile.png": 1766,
	"./resources/images/zh-HK/ehealth_website_banner_desktop.jpg": 1767,
	"./resources/images/zh-HK/ehealth_website_banner_mobile.jpg": 1768,
	"./resources/images/zh-HK/ehealthpro_acc_mgmt_slider_phone1.png": 1769,
	"./resources/images/zh-HK/ehealthpro_faq-banner-graphic.png": 1770,
	"./resources/images/zh-HK/ehealthpro_info_share_slider_phone1.png": 1771,
	"./resources/images/zh-HK/ehealthpro_mini_assistant_slider_phone1.png": 1772,
	"./resources/images/zh-HK/ehealthpro_noti_center_slider_phone1.png": 1773,
	"./resources/images/zh-HK/ehealthpro_noti_center_slider_phone2.png": 1774,
	"./resources/images/zh-HK/ehealthpro_slider_phone1.png": 1775,
	"./resources/images/zh-HK/faq-banner-graphic.png": 1776,
	"./resources/images/zh-HK/google_play.png": 1777,
	"./resources/images/zh-HK/health-management_p1_1.png": 1778,
	"./resources/images/zh-HK/health-management_p2_1.png": 1779,
	"./resources/images/zh-HK/health-management_p3_1.png": 1780,
	"./resources/images/zh-HK/health-management_p3_2.png": 1781,
	"./resources/images/zh-HK/health-management_p4_1.png": 1782,
	"./resources/images/zh-HK/health-program_cb_1.png": 1783,
	"./resources/images/zh-HK/health-program_p0_1.png": 1784,
	"./resources/images/zh-HK/health-program_p0_2.png": 1785,
	"./resources/images/zh-HK/health-program_p1_1.png": 1786,
	"./resources/images/zh-HK/health-program_p1_2.png": 1787,
	"./resources/images/zh-HK/health-program_p2_2.png": 1788,
	"./resources/images/zh-HK/health-program_p3_1.png": 1789,
	"./resources/images/zh-HK/health-program_p4_1.png": 1790,
	"./resources/images/zh-HK/health-program_p4_3.png": 1791,
	"./resources/images/zh-HK/healthcare_doc_p1_1.png": 1792,
	"./resources/images/zh-HK/healthcare_doc_slider_phone1.png": 1793,
	"./resources/images/zh-HK/healthcare_doc_slider_phone2.png": 1794,
	"./resources/images/zh-HK/healthcare_doc_slider_phone3.png": 1795,
	"./resources/images/zh-HK/home_allergy.png": 1796,
	"./resources/images/zh-HK/home_appointments.png": 1797,
	"./resources/images/zh-HK/home_caregiver.png": 1798,
	"./resources/images/zh-HK/home_cbhr.png": 1799,
	"./resources/images/zh-HK/home_family_doctor.png": 1800,
	"./resources/images/zh-HK/home_health_news.png": 1801,
	"./resources/images/zh-HK/home_health_programme.png": 1802,
	"./resources/images/zh-HK/home_healthcare_document.png": 1803,
	"./resources/images/zh-HK/home_investigation.png": 1804,
	"./resources/images/zh-HK/home_investigations.png": 1805,
	"./resources/images/zh-HK/home_medical_certificate.png": 1806,
	"./resources/images/zh-HK/home_medical_certificate_icon.png": 1807,
	"./resources/images/zh-HK/home_medication.png": 1808,
	"./resources/images/zh-HK/home_personal_folder.png": 1809,
	"./resources/images/zh-HK/home_vaccine.png": 1810,
	"./resources/images/zh-HK/huawei.png": 1811,
	"./resources/images/zh-HK/img_growth.png": 1812,
	"./resources/images/zh-HK/investigation_p1_1.png": 1813,
	"./resources/images/zh-HK/investigation_p2_1.png": 1814,
	"./resources/images/zh-HK/investigation_radi_1.png": 1815,
	"./resources/images/zh-HK/investigation_slider_phone1.png": 1816,
	"./resources/images/zh-HK/investigation_slider_phone2.png": 1817,
	"./resources/images/zh-HK/investigation_slider_phone3.png": 1818,
	"./resources/images/zh-HK/land-elife-banner-img-mobile.jpg": 1819,
	"./resources/images/zh-HK/land-elife-banner-img.jpg": 1820,
	"./resources/images/zh-HK/land-scanner-banner-img-mobile.jpg": 1821,
	"./resources/images/zh-HK/land-scanner-banner-img.jpg": 1822,
	"./resources/images/zh-HK/landing-health-management-phone.png": 1823,
	"./resources/images/zh-HK/landing-slider-img-1-mobile.jpg": 1824,
	"./resources/images/zh-HK/landing-slider-img-1.jpg": 1825,
	"./resources/images/zh-HK/landing-vaccine-phone.png": 1826,
	"./resources/images/zh-HK/landing.png": 1827,
	"./resources/images/zh-HK/life-faq-banner-graphic.png": 1828,
	"./resources/images/zh-HK/management_slider_phone1.png": 1829,
	"./resources/images/zh-HK/management_slider_phone2.png": 1830,
	"./resources/images/zh-HK/management_slider_phone3.png": 1831,
	"./resources/images/zh-HK/medical_cert_p1_1.png": 1832,
	"./resources/images/zh-HK/medical_cert_p1_2.png": 1833,
	"./resources/images/zh-HK/medical_cert_p2_1.png": 1834,
	"./resources/images/zh-HK/medical_cert_p2_3.png": 1835,
	"./resources/images/zh-HK/medical_cert_p3_1.png": 1836,
	"./resources/images/zh-HK/medical_cert_slider_phone1.png": 1837,
	"./resources/images/zh-HK/medication_p1_2.png": 1838,
	"./resources/images/zh-HK/medication_p2_1.png": 1839,
	"./resources/images/zh-HK/medication_slider_phone1.png": 1840,
	"./resources/images/zh-HK/medication_slider_phone2.png": 1841,
	"./resources/images/zh-HK/medication_slider_phone3.png": 1842,
	"./resources/images/zh-HK/mobile-promotion_content.png": 1843,
	"./resources/images/zh-HK/mobile_child_usage0.png": 1844,
	"./resources/images/zh-HK/mobile_child_usage1.png": 1845,
	"./resources/images/zh-HK/mobile_download_phone.png": 1846,
	"./resources/images/zh-HK/my-family-campaign-banner-desktop.jpg": 1847,
	"./resources/images/zh-HK/my-family-campaign-banner-mobile.jpg": 1848,
	"./resources/images/zh-HK/my_family_doctor_p1_1.png": 1849,
	"./resources/images/zh-HK/my_family_doctor_slider_phone1.png": 1850,
	"./resources/images/zh-HK/new-item-tag.png": 1851,
	"./resources/images/zh-HK/news_p1_2.png": 1852,
	"./resources/images/zh-HK/news_p2_1.png": 1853,
	"./resources/images/zh-HK/news_p2_2.png": 1854,
	"./resources/images/zh-HK/news_slider_phone1.png": 1855,
	"./resources/images/zh-HK/news_slider_phone2.png": 1856,
	"./resources/images/zh-HK/on_one.png": 1857,
	"./resources/images/zh-HK/on_three.png": 1858,
	"./resources/images/zh-HK/on_two.png": 1859,
	"./resources/images/zh-HK/page-not-found.jpg": 1860,
	"./resources/images/zh-HK/personal_folder_p1_1.png": 1861,
	"./resources/images/zh-HK/personal_folder_p2_1.png": 1862,
	"./resources/images/zh-HK/personal_folder_slider_phone1.png": 1863,
	"./resources/images/zh-HK/personal_folder_tip_1.png": 1864,
	"./resources/images/zh-HK/personal_folder_tip_2.png": 1865,
	"./resources/images/zh-HK/privacy/keep-safe-tip05.png": 1866,
	"./resources/images/zh-HK/privacy/keep-safe-tip06.png": 1867,
	"./resources/images/zh-HK/program_slider_phone1.png": 1868,
	"./resources/images/zh-HK/program_slider_phone2.png": 1869,
	"./resources/images/zh-HK/program_slider_phone3.png": 1870,
	"./resources/images/zh-HK/promotion_content.png": 1871,
	"./resources/images/zh-HK/qr-baby.png": 1872,
	"./resources/images/zh-HK/qr_code_slider_phone1.png": 1873,
	"./resources/images/zh-HK/qr_code_slider_phone2.png": 1874,
	"./resources/images/zh-HK/qr_code_slider_phone3.png": 1875,
	"./resources/images/zh-HK/qr_code_slider_phone4.png": 1876,
	"./resources/images/zh-HK/qr_scanner_p1_1.png": 1877,
	"./resources/images/zh-HK/search_slider_phone1.png": 1878,
	"./resources/images/zh-HK/search_slider_phone2.png": 1879,
	"./resources/images/zh-HK/search_slider_phone3.png": 1880,
	"./resources/images/zh-HK/slider_phone1.png": 1881,
	"./resources/images/zh-HK/slider_phone2.png": 1882,
	"./resources/images/zh-HK/slider_phone3.png": 1883,
	"./resources/images/zh-HK/terms-banner-graphic.png": 1884,
	"./resources/images/zh-HK/truck-main-img.jpg": 1885,
	"./resources/images/zh-HK/truck-schedule-1.jpg": 1886,
	"./resources/images/zh-HK/truck-schedule-2.jpg": 1887,
	"./resources/images/zh-HK/under-16-input-info-2.png": 1888,
	"./resources/images/zh-HK/under16-gift-banner-desktop.jpg": 1889,
	"./resources/images/zh-HK/under16-gift-banner-desktop.png": 1890,
	"./resources/images/zh-HK/under16-gift-banner-mobile.jpg": 1891,
	"./resources/images/zh-HK/under16-gift-banner-mobile.png": 1892,
	"./resources/images/zh-HK/vaccine_p1_2.png": 1893,
	"./resources/images/zh-HK/vaccine_p2_1.png": 1894,
	"./resources/images/zh-HK/vaccine_p3_2.png": 1895,
	"./resources/images/zh-HK/vaccine_slider_phone1.png": 1896,
	"./resources/images/zh-HK/vaccine_slider_phone2.png": 1897,
	"./resources/images/zh-HK/vaccine_slider_phone3.png": 1898,
	"./resources/images/zh-HK/what-new-banner-desktop.jpg": 1899,
	"./resources/images/zh-HK/what-new-banner-mobile.jpg": 1900,
	"./resources/images/zh-HK/what-new-banner.jpg": 1901,
	"./resources/languages": 116,
	"./resources/languages/": 116,
	"./resources/languages/accessibility/en": 161,
	"./resources/languages/accessibility/en.json": 161,
	"./resources/languages/accessibility/zh-CN": 163,
	"./resources/languages/accessibility/zh-CN.json": 163,
	"./resources/languages/accessibility/zh-HK": 162,
	"./resources/languages/accessibility/zh-HK.json": 162,
	"./resources/languages/en": 167,
	"./resources/languages/en.json": 167,
	"./resources/languages/index": 116,
	"./resources/languages/index.js": 116,
	"./resources/languages/privacyGame/en": 164,
	"./resources/languages/privacyGame/en.json": 164,
	"./resources/languages/privacyGame/zh-CN": 166,
	"./resources/languages/privacyGame/zh-CN.json": 166,
	"./resources/languages/privacyGame/zh-HK": 165,
	"./resources/languages/privacyGame/zh-HK.json": 165,
	"./resources/languages/vaccineCalculator/en": 158,
	"./resources/languages/vaccineCalculator/en.json": 158,
	"./resources/languages/vaccineCalculator/zh-CN": 160,
	"./resources/languages/vaccineCalculator/zh-CN.json": 160,
	"./resources/languages/vaccineCalculator/zh-HK": 159,
	"./resources/languages/vaccineCalculator/zh-HK.json": 159,
	"./resources/languages/zh-CN": 169,
	"./resources/languages/zh-CN.json": 169,
	"./resources/languages/zh-HK": 168,
	"./resources/languages/zh-HK.json": 168,
	"./resources/styles/bannerSlider.scss": 35,
	"./resources/styles/bootstrap.min.scss": 291,
	"./resources/styles/elifeCoins.scss": 267,
	"./resources/styles/elifeLeaderboard.scss": 268,
	"./resources/styles/elifeParklist.scss": 269,
	"./resources/styles/elifeRemption.scss": 273,
	"./resources/styles/privacyGame.scss": 274,
	"./resources/styles/promotion.scss": 290,
	"./resources/styles/responsiveMenu.scss": 292,
	"./resources/styles/sliderAnimation.scss": 293,
	"./resources/styles/style.scss": 294,
	"./resources/utils/commonUtils": 11,
	"./resources/utils/commonUtils.js": 11,
	"./resources/utils/dateUtils": 10,
	"./resources/utils/dateUtils.js": 10,
	"./resources/utils/stringUtils": 14,
	"./resources/utils/stringUtils.js": 14,
	"./resources/utils/validator": 8,
	"./resources/utils/validator.js": 8,
	"./serviceWorker": 145,
	"./serviceWorker.js": 145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;